"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6117],{

/***/ 81087:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(11717);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(71618);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26950);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9150);
/* harmony import */ var chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82740);
/* harmony import */ var _components_common_Badge__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63732);
/* harmony import */ var _components_common_RoundAvatar__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(81794);
/* harmony import */ var _contexts_global__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30259);
/* harmony import */ var _utils_chat__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(42127);
/* harmony import */ var _utils_date__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9987);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    padding: ",
        "px ",
        "px ",
        "px\n      ",
        "px;\n    height: 68px;\n    ",
        ";\n    ",
        ";\n    color: ",
        ";\n    overflow: visible;\n    position: relative;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 10px;\n  position: absolute;\n  bottom: 8px;\n\n  span {\n    height: 16px;\n    line-height: 16px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 10px;\n  position: absolute;\n  bottom: 8px;\n  left: 21px;\n  padding: 0 2px;\n\n  span {\n    height: 16px;\n    line-height: 16px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    flex-direction: ",
        ";\n    margin-left: ",
        "px;\n    width: 100%;\n    justify-content: ",
        ";\n    ",
        ";\n\n    p {\n      ",
        ";\n      color: ",
        ";\n      line-height: 135%;\n    }\n\n    .date {\n      text-align: end;\n      width: 70px;\n      min-width: 70px;\n      max-width: 70px;\n    }\n\n    .character-name {\n      display: flex;\n      text-align: left;\n      align-item: center;\n      line-height: 135%;\n      gap: ",
        "px;\n\n      .new-badge {\n        display: flex;\n        align-items: center;\n      }\n    }\n\n    .last-message {\n      text-align: left;\n    }\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  text-align: center;\n  justify-content: space-between;\n\n  h5 {\n    ",
        ";\n    align-self: start;\n    line-height: 100%;\n  }\n\n  .character-name {\n    display: flex;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: ",
        "px;\n  align-self: start;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: ",
        ";\n  top: 50%;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  margin-top: 6px;\n  gap: 10px;\n\n  .tab-container,\n  .balloon-container {\n    display: flex;\n    flex-direction: row;\n    gap: 2px;\n    align-items: center;\n    text-align: center;\n\n    & p {\n      ",
        ";\n    }\n\n    .tab {\n      color: ",
        ";\n    }\n    .balloon {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}










var chatRoomCSS = function(isBorder) {
    return function(theme) {
        return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject(), chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.small */ .Ki.small, chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.small */ .Ki.small, chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.small */ .Ki.small, chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.medium */ .Ki.medium, isBorder ? "border: 1px solid ".concat(theme.colors.main500) : null, isBorder ? "border-radius: 5px" : null, theme.var.gray900);
    };
};
var badgeCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject1());
var adultBadgeCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject2());
var chatRoomHeaderCSS = function(isEdit) {
    return function(theme) {
        return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject3(), isEdit ? "row" : "column", chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.medium */ .Ki.medium, isEdit ? "space-between" : "center", isEdit ? "align-items: center" : "null", chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Typography.body12 */ .ZT.body12, theme.var.gray500, chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.xhsmall */ .Ki.xhsmall);
    };
};
var chatRoomTopHeaderCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject4(), chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Typography.h5 */ .ZT.h5);
var chatRoomBottomHeaderCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject5(), chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.xxsmall */ .Ki.xxsmall);
var storySelecButtonCSS = function(theme) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject6(), theme.var.black);
};
var statCSS = function(theme) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject7(), chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Typography.body12 */ .ZT.body12, theme.colors.main500, theme.var.gray500);
};
var ChatRoom = function(param) {
    var chatRoomInfo = param.chatRoomInfo, _isEdit = param.isEdit, isEdit = _isEdit === void 0 ? false : _isEdit, _isCheck = param.isCheck, isCheck = _isCheck === void 0 ? false : _isCheck, _isBorder = param.isBorder, isBorder = _isBorder === void 0 ? false : _isBorder, right = param.right, onClickAvatar = param.onClickAvatar, _isNewCharacter = param.isNewCharacter, isNewCharacter = _isNewCharacter === void 0 ? false : _isNewCharacter, isDeletedCharacter = param.isDeletedCharacter, isMyCharacter = param.isMyCharacter, isAdultChatRoom = param.isAdultChatRoom;
    var ref, ref1, ref2;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_0__/* .useTranslation */ .$G)().t;
    var theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__.u)();
    var mainFill = (0,_components_common_Badge__WEBPACK_IMPORTED_MODULE_3__/* .useBadgePresets */ .fw)().mainFill;
    var isCheming = (0,_contexts_global__WEBPACK_IMPORTED_MODULE_5__/* .useGlobalContext */ .bN)().isCheming;
    var getFormattedDate = function(lastMessageDate) {
        var koreanDate = new Date(lastMessageDate);
        var currentKoreanDate = new Date();
        var currentKoreanDateOnly = new Date(currentKoreanDate.setHours(0, 0, 0, 0));
        var koreanDateOnly = new Date(koreanDate.setHours(0, 0, 0, 0));
        var diff = (0,_utils_date__WEBPACK_IMPORTED_MODULE_7__/* .differenceInDays */ .jc)(currentKoreanDateOnly, koreanDateOnly);
        if (diff < 1) {
            return (0,_utils_date__WEBPACK_IMPORTED_MODULE_7__/* .formatDate */ .p6)(lastMessageDate, "a h:mm");
        } else if (diff >= 1 && diff < 2) {
            return "어제";
        } else {
            return "".concat(diff, "일 전");
        }
    };
    var ref3;
    var lastMessageDate = (ref3 = chatRoomInfo === null || chatRoomInfo === void 0 ? void 0 : chatRoomInfo.lastMessageDate) !== null && ref3 !== void 0 ? ref3 : "";
    var parsedLastMessageDate = getFormattedDate(lastMessageDate);
    var hasPeek = (chatRoomInfo === null || chatRoomInfo === void 0 ? void 0 : (ref = chatRoomInfo.peek) === null || ref === void 0 ? void 0 : ref.status) === "AT";
    var ref4, ref5;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.Fragment, {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("article", {
            css: chatRoomCSS(isBorder),
            className: "chat-room-container",
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                    onClick: function() {
                        return onClickAvatar ? onClickAvatar() : null;
                    },
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_components_common_RoundAvatar__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            size: 44,
                            picture: chatRoomInfo.image
                        }),
                        isMyCharacter && !isAdultChatRoom && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_components_common_Badge__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, _objectSpreadProps(_objectSpread({
                            text: t("내 캐릭터")
                        }, mainFill), {
                            css: badgeCSS
                        })),
                        isAdultChatRoom && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_components_common_Badge__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, _objectSpreadProps(_objectSpread({
                            text: t("\uD83E\uDD2B 쉿")
                        }, mainFill), {
                            css: adultBadgeCSS
                        }))
                    ]
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                    css: chatRoomHeaderCSS(!!isEdit || !!right),
                    className: "chat-room-header",
                    children: [
                        !right && !isEdit && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                            onClick: function() {
                                return onClickAvatar ? onClickAvatar() : null;
                            },
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                                    css: chatRoomTopHeaderCSS,
                                    children: [
                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                                            className: "character-name",
                                            children: [
                                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("h5", {
                                                    children: t("{{characterName}}", {
                                                        characterName: isDeletedCharacter ? "알 수 없음" : chatRoomInfo.characterName
                                                    })
                                                }),
                                                isNewCharacter && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_components_common_Badge__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                                                    text: "새 캐릭터 등장 \uD83D\uDC40",
                                                    backgroundColor: isCheming ? "linear-gradient(180deg, #7F00FF, #8E2DE2)" : "linear-gradient(90deg, #04C8D0, #1590D5)",
                                                    fontSize: 10,
                                                    className: "new-badge"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("p", {
                                            className: "date",
                                            children: t("{{lastMessageDate}}", {
                                                lastMessageDate: parsedLastMessageDate
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                                    css: chatRoomBottomHeaderCSS,
                                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("p", {
                                        className: "last-message",
                                        children: t("{{lastMessage}}", {
                                            lastMessage: isDeletedCharacter ? "삭제된 캐릭터 입니다." : chatRoomInfo.lastMessage
                                        })
                                    })
                                }),
                                !!hasPeek && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                                    className: "stat-container",
                                    css: statCSS,
                                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                                        className: "tab-container",
                                        children: [
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .JO, {
                                                icon: chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_2__/* .Tap */ .Uw,
                                                size: chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Sizes.xsmall */ .u8.xsmall,
                                                color: theme.colors.main500
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("p", {
                                                className: "tab",
                                                children: t((0,_utils_chat__WEBPACK_IMPORTED_MODULE_6__/* .formatNumberMillion */ .OQ)((ref4 = chatRoomInfo === null || chatRoomInfo === void 0 ? void 0 : (ref1 = chatRoomInfo.peek) === null || ref1 === void 0 ? void 0 : ref1.tap_count) !== null && ref4 !== void 0 ? ref4 : 0))
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        (isEdit || right) && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                                    onClick: function() {
                                        return onClickAvatar ? onClickAvatar() : null;
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                                            css: chatRoomTopHeaderCSS,
                                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                                                className: "character-name",
                                                children: [
                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("h5", {
                                                        children: t("{{characterName}}", {
                                                            characterName: isDeletedCharacter ? "알 수 없음" : chatRoomInfo.characterName
                                                        })
                                                    }),
                                                    isNewCharacter && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_components_common_Badge__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                                                        text: "새 캐릭터 등장 \uD83D\uDC40",
                                                        backgroundColor: isCheming ? "linear-gradient(180deg, #7F00FF, #8E2DE2)" : "linear-gradient(90deg, #04C8D0, #1590D5)",
                                                        fontSize: 10,
                                                        className: "new-badge"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                                            css: chatRoomBottomHeaderCSS,
                                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("p", {
                                                className: "last-message",
                                                children: t("{{lastMessage}}", {
                                                    lastMessage: isDeletedCharacter ? "삭제된 캐릭터 입니다." : chatRoomInfo.lastMessage
                                                })
                                            })
                                        }),
                                        hasPeek && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                                            className: "stat-container",
                                            css: statCSS,
                                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                                                className: "tab-container",
                                                children: [
                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .JO, {
                                                        icon: chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_2__/* .Tap */ .Uw,
                                                        size: chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Sizes.xsmall */ .u8.xsmall,
                                                        color: theme.colors.main500
                                                    }),
                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("p", {
                                                        className: "tab",
                                                        children: t((0,_utils_chat__WEBPACK_IMPORTED_MODULE_6__/* .formatNumberMillion */ .OQ)((ref5 = chatRoomInfo === null || chatRoomInfo === void 0 ? void 0 : (ref2 = chatRoomInfo.peek) === null || ref2 === void 0 ? void 0 : ref2.tap_count) !== null && ref5 !== void 0 ? ref5 : 0))
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                right !== null && right !== void 0 ? right : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("button", {
                                    css: storySelecButtonCSS,
                                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .JO, {
                                        icon: chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_2__/* .CheckCircle */ .fU,
                                        size: chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Sizes.large */ .u8.large,
                                        color: isCheck ? theme.colors.main500 : theme.var.gray200
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ChatRoom);


/***/ }),

/***/ 6913:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Kj": function() { return /* binding */ BannerSize; },
/* harmony export */   "Rt": function() { return /* binding */ BannerKey; },
/* harmony export */   "fg": function() { return /* binding */ KeyBanner; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(11717);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47311);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54909);
/* harmony import */ var react_responsive_carousel__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61871);
/* harmony import */ var react_responsive_carousel_lib_styles_carousel_min_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24123);
/* harmony import */ var react_responsive_carousel_lib_styles_carousel_min_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_responsive_carousel_lib_styles_carousel_min_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39854);
/* harmony import */ var _contexts_global__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30259);
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96964);
/* harmony import */ var _utils_analytics__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3263);
/* harmony import */ var _api_common__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(98379);
/* harmony import */ var _utils_webview__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(81946);
/* harmony import */ var _layout_Border__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(95567);
/* harmony import */ var _EFinderImage__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(11247);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  padding-bottom: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        " {\n    max-width: 500px;\n    margin: 0 auto;\n    border-radius: 12px;\n    overflow: hidden;\n  }\n  ",
        " {\n    max-width: 560px;\n    border-radius: 16px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}














var BannerSize;
(function(BannerSize) {
    BannerSize["curation"] = "38.8889%";
    BannerSize["promotion"] = "20%";
    BannerSize["home"] = "56.25%";
    BannerSize["playHome"] = "48%";
})(BannerSize || (BannerSize = {}));
var bannerItemCSS = function(size) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_12__.css)(_templateObject(), typeof size === "number" ? "".concat(size, "px") : size);
};
var responsiveBannerCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_12__.css)(_templateObject1(), _styles_css__WEBPACK_IMPORTED_MODULE_6__/* .media.tablet */ .BC.tablet, _styles_css__WEBPACK_IMPORTED_MODULE_6__/* .media.desktop */ .BC.desktop);
var Banner = function(param) {
    var name = param.name, _isBorder = param.isBorder, isBorder = _isBorder === void 0 ? true : _isBorder, size = param.size, items = param.items, _priority = param.priority, priority = _priority === void 0 ? false : _priority, _autoPlay = param.autoPlay, autoPlay = _autoPlay === void 0 ? true : _autoPlay;
    var platform = (0,_contexts_global__WEBPACK_IMPORTED_MODULE_5__/* .useGlobalContext */ .bN)().platform;
    var web = (0,_utils_webview__WEBPACK_IMPORTED_MODULE_9__/* .useWebView */ .B9)().web;
    var firebase = (0,_utils_analytics__WEBPACK_IMPORTED_MODULE_7__/* .useAnalytics */ .z)().firebase;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    if (items.length === 0) {
        return null;
    }
    var _height;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.Fragment, {
        children: [
            isBorder && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(_layout_Border__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                type: _layout_Border__WEBPACK_IMPORTED_MODULE_10__/* .BorderType.space */ .T.space
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(react_responsive_carousel__WEBPACK_IMPORTED_MODULE_2__/* .Carousel */ .lr, {
                css: responsiveBannerCSS,
                autoPlay: autoPlay,
                showIndicators: items.length > 1,
                showThumbs: false,
                showStatus: false,
                showArrows: false,
                infiniteLoop: true,
                emulateTouch: true,
                onClickItem: function(i) {
                    if (name === "play-full-screen=banner") {
                        firebase.logEvent("chatbot_click_play_curation", {
                            curation_view_type: "full_screen_banner"
                        });
                    }
                    var url = items[i].url;
                    if (url) {
                        if (platform === _constants__WEBPACK_IMPORTED_MODULE_4__/* .Platform.web */ .t4.web) {
                            router.push(url);
                        }
                        web.openUrl(url);
                    }
                },
                children: items.map(function(item, idx) {
                    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("div", {
                        css: bannerItemCSS(size !== null && size !== void 0 ? size : ((_height = item.image.attachment.height) !== null && _height !== void 0 ? _height : 150) / 3),
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(_EFinderImage__WEBPACK_IMPORTED_MODULE_11__/* .OptimizeEFinderImage */ .yK, {
                            image: item.image,
                            h: _EFinderImage__WEBPACK_IMPORTED_MODULE_11__/* .EFinderImageSizes.banner */ .ny.banner,
                            loading: idx === 0 && priority ? "eager" : "lazy",
                            priority: idx === 0 && priority
                        })
                    }, "banner-".concat(name, "-").concat(item.id));
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (Banner);
var BannerKey;
(function(BannerKey) {
    BannerKey["story"] = "story";
    BannerKey["myStory"] = "my_story";
})(BannerKey || (BannerKey = {}));
var KeyBanner = function(param) {
    var bKey = param.bKey, size = param.size;
    var query = (0,react_query__WEBPACK_IMPORTED_MODULE_1__.useQuery)([
        "banners",
        bKey
    ], function() {
        return (0,_api_common__WEBPACK_IMPORTED_MODULE_8__/* .fetchBanners */ .f8)(bKey);
    }, {
        suspense: false,
        staleTime: Infinity,
        cacheTime: Infinity
    });
    var data = query.data;
    if (!data) {
        return null;
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(Banner, {
        name: bKey,
        size: size,
        items: data
    });
};


/***/ }),

/***/ 80521:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11717);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39953);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 0;\n  height: 0;\n  overflow: hidden;\n\n  &.adsense-loaded {\n    height: auto;\n    border-top: 8px solid ",
        ";\n    border-bottom: 8px solid ",
        ";\n  }\n\n  &.adsense-failed {\n    display: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 11px;\n  color: ",
        ";\n  padding: 4px 12px 0;\n  line-height: 1;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px;\n  background: ",
        ";\n  border: 1px dashed ",
        ";\n  border-radius: 8px;\n  margin: 4px 0;\n\n  .dev-ad-icon {\n    width: 48px;\n    height: 48px;\n    border-radius: 8px;\n    background: linear-gradient(\n      135deg,\n      ",
        ",\n      ",
        "\n    );\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 20px;\n  }\n\n  .dev-ad-content {\n    flex: 1;\n    min-width: 0;\n  }\n\n  .dev-ad-label {\n    font-size: 10px;\n    color: ",
        ";\n    margin-bottom: 2px;\n  }\n\n  .dev-ad-title {\n    font-size: 14px;\n    font-weight: 600;\n    color: ",
        ";\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .dev-ad-body {\n    font-size: 12px;\n    color: ",
        ";\n    margin-top: 2px;\n  }\n\n  .dev-ad-cta {\n    font-size: 11px;\n    font-weight: 600;\n    color: white;\n    background: ",
        ";\n    border: none;\n    border-radius: 14px;\n    padding: 6px 14px;\n    flex-shrink: 0;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var containerCSS = function(theme) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__.css)(_templateObject(), theme.border.space, theme.border.space);
};
var adLabelCSS = function(theme) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__.css)(_templateObject1(), theme.var.gray400);
};
var devPreviewCSS = function(theme) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__.css)(_templateObject2(), theme.var.gray50, theme.var.gray300, theme.var.gray200, theme.var.gray300, theme.var.gray400, theme.var.gray700, theme.var.gray500, theme.colors.main500);
};
var AD_UNITS = {
    home_cp_mobile: {
        slot: "1147096797" || 0,
        layoutKey: "-7t+er-i-q+3d" || 0
    },
    home_sr_mobile: {
        slot: "5407973686" || 0,
        layoutKey: "-hj" || 0
    },
    feed_default_mobile: {
        slot: "9380810036" || 0,
        layoutKey: "-fl+5f+76-cs-1m" || 0
    },
    library_mobile: {
        slot: "5316474349" || 0,
        layoutKey: "-bl+bt-3y-7x+tm" || 0
    },
    story_mobile: {
        slot: "9181499480" || 0,
        layoutKey: "-fj+65+1s-bv+er" || 0
    },
    episode_mobile: {
        slot: "8798356107" || 0,
        layoutKey: "-b5+bp-3d-6j+ow" || 0
    }
};
var ADSENSE_CLIENT = "";
var IS_DEV = !!ADSENSE_CLIENT && "object" !== "undefined" && window.location.hostname === "localhost";
// 스크립트 중복 삽입 방지용 모듈 스코프 플래그
var adsenseScriptState = "idle";
var adsenseLoadCallbacks = [];
var NativeInFeedAd = function(param) {
    var unitKey = param.unitKey;
    var containerRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var insRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isVisible = ref[0], setIsVisible = ref[1];
    var pushedRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    var adUnit = AD_UNITS[unitKey];
    var isEnabled = !!(ADSENSE_CLIENT && (adUnit === null || adUnit === void 0 ? void 0 : adUnit.slot));
    // IntersectionObserver: 뷰포트 200px 이내 진입 시 로드
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!isEnabled && !IS_DEV || !containerRef.current) return;
        var observer = new IntersectionObserver(function(param) {
            var _param = _slicedToArray(param, 1), entry = _param[0];
            if (entry.isIntersecting) {
                setIsVisible(true);
                observer.disconnect();
            }
        }, {
            rootMargin: "200px"
        });
        observer.observe(containerRef.current);
        return function() {
            return observer.disconnect();
        };
    }, [
        isEnabled
    ]);
    // AdSense 스크립트 로드 + push
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!isEnabled || !isVisible || pushedRef.current || IS_DEV) return;
        var pushAd = function() {
            try {
                (window.adsbygoogle = window.adsbygoogle || []).push({});
                pushedRef.current = true;
            } catch (e) {
                console.warn("[AdSense InFeed] push error:", e);
            }
        };
        if (adsenseScriptState === "loaded") {
            pushAd();
            return;
        }
        if (adsenseScriptState === "loading") {
            adsenseLoadCallbacks.push(pushAd);
            return;
        }
        // 최초 1회 스크립트 삽입
        adsenseScriptState = "loading";
        adsenseLoadCallbacks.push(pushAd);
        var script = document.createElement("script");
        script.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=".concat(ADSENSE_CLIENT);
        script.async = true;
        script.crossOrigin = "anonymous";
        script.onload = function() {
            adsenseScriptState = "loaded";
            adsenseLoadCallbacks.forEach(function(cb) {
                return cb();
            });
            adsenseLoadCallbacks.length = 0;
        };
        script.onerror = function() {
            adsenseScriptState = "idle";
            adsenseLoadCallbacks.length = 0;
            console.warn("[AdSense InFeed] script load failed");
        };
        document.head.appendChild(script);
    }, [
        isEnabled,
        isVisible
    ]);
    // 로드 완료 감지 + 타임아웃 시 숨김
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!insRef.current || !isVisible || IS_DEV) return;
        var loaded = false;
        var observer = new MutationObserver(function() {
            if (insRef.current && insRef.current.childElementCount > 0 && containerRef.current) {
                loaded = true;
                containerRef.current.classList.add("adsense-loaded");
                observer.disconnect();
            }
        });
        observer.observe(insRef.current, {
            childList: true,
            subtree: true
        });
        // 5초 내 로드 안 되면 숨김
        var timeout = setTimeout(function() {
            if (!loaded && containerRef.current) {
                containerRef.current.classList.add("adsense-failed");
                observer.disconnect();
            }
        }, 5000);
        return function() {
            observer.disconnect();
            clearTimeout(timeout);
        };
    }, [
        isVisible
    ]);
    if (!isEnabled && !IS_DEV) return null;
    // 로컬 개발 환경: 미리보기 플레이스홀더
    if (IS_DEV) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
            ref: containerRef,
            css: devPreviewCSS,
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
                    className: "dev-ad-icon",
                    children: "AD"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
                    className: "dev-ad-content",
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
                            className: "dev-ad-label",
                            children: [
                                "AdSense InFeed \xb7 ",
                                unitKey
                            ]
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
                            className: "dev-ad-title",
                            children: "광고 제목이 여기에 표시됩니다"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
                            className: "dev-ad-body",
                            children: "광고 설명 텍스트 미리보기"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("button", {
                    type: "button",
                    className: "dev-ad-cta",
                    children: "자세히"
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
        ref: containerRef,
        css: containerCSS,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
                css: adLabelCSS,
                children: "광고"
            }),
            isVisible && adUnit && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("ins", {
                ref: insRef,
                className: "adsbygoogle",
                style: {
                    display: "block"
                },
                "data-ad-format": "fluid",
                "data-ad-layout-key": adUnit.layoutKey,
                "data-ad-client": ADSENSE_CLIENT,
                "data-ad-slot": adUnit.slot
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NativeInFeedAd);


/***/ }),

/***/ 95567:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ BorderType; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11717);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71618);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  border-bottom-width: ",
        "px;\n  border-style: ",
        ";\n  border-color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var BorderType;
(function(BorderType) {
    BorderType["line"] = "line";
    BorderType["space"] = "space";
})(BorderType || (BorderType = {}));
var borderCSS = function(color, style, size) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject(), size, style, color);
};
var Border = function(param) {
    var className = param.className, color = param.color, _type = param.type, type = _type === void 0 ? BorderType.line : _type, _style = param.style, style = _style === void 0 ? "solid" : _style;
    var theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__.u)();
    if (type === BorderType.space) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
            css: borderCSS(color !== null && color !== void 0 ? color : theme.border.space, style, 8),
            className: className
        });
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
        css: borderCSS(color !== null && color !== void 0 ? color : theme.border.lightest, style, 1),
        className: className
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Border);


/***/ }),

/***/ 91708:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11717);
/** @jsxImportSource @emotion/react */ function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  background-color: ",
        ";\n  height: ",
        "px;\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var dividerStyle = function(height) {
    return function(theme) {
        return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject(), theme.var.gray100, height !== null && height !== void 0 ? height : 10);
    };
};
var Divider = function(param) {
    var _data = param.data, data = _data === void 0 ? {
        height: 8
    } : _data;
    var height = data.height;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        css: dividerStyle(height)
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Divider);


/***/ }),

/***/ 3455:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ outlook_OutlookComponent; }
});

// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-7a26ef4a22/0/cache/@emotion-react-npm-11.11.1-a07d6a6ebd-aec3c36650.zip/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(8683);
// EXTERNAL MODULE: ./.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(39953);
// EXTERNAL MODULE: ./components/common/Banner.tsx
var Banner = __webpack_require__(6913);
// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-7a26ef4a22/0/cache/@emotion-react-npm-11.11.1-a07d6a6ebd-aec3c36650.zip/node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(11717);
// EXTERNAL MODULE: ./.yarn/__virtual__/next-i18next-virtual-9e5d267e7d/0/cache/next-i18next-npm-12.1.0-68b3291791-8c0e2f9764.zip/node_modules/next-i18next/dist/esm/index.js + 43 modules
var esm = __webpack_require__(26950);
// EXTERNAL MODULE: ./.yarn/__virtual__/next-virtual-9251101693/0/cache/next-npm-12.3.4-cdaf2db0a7-d96fc4f5bc.zip/node_modules/next/router.js
var next_router = __webpack_require__(47311);
// EXTERNAL MODULE: ./.yarn/__virtual__/chatie-design-system-virtual-6d39449242/0/cache/chatie-design-system-https-edc3b42f07-dc9424d6a3.zip/node_modules/chatie-design-system/dist/esm/index.js + 10 modules
var dist_esm = __webpack_require__(9150);
// EXTERNAL MODULE: ./styles/css.tsx
var css = __webpack_require__(96964);
// EXTERNAL MODULE: ./components/common/Badge.tsx
var Badge = __webpack_require__(63732);
// EXTERNAL MODULE: ./components/common/EFinderImage.tsx
var EFinderImage = __webpack_require__(11247);
// EXTERNAL MODULE: ./components/common/RoundAvatar.tsx
var RoundAvatar = __webpack_require__(81794);
// EXTERNAL MODULE: ./components/common/SwipableListContainer.tsx
var SwipableListContainer = __webpack_require__(95728);
// EXTERNAL MODULE: ./constants/index.ts
var constants = __webpack_require__(39854);
// EXTERNAL MODULE: ./contexts/global.ts
var global = __webpack_require__(30259);
// EXTERNAL MODULE: ./utils/date.ts + 31 modules
var date = __webpack_require__(9987);
// EXTERNAL MODULE: ./utils/webview.ts
var webview = __webpack_require__(81946);
// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-7a26ef4a22/0/cache/@emotion-react-npm-11.11.1-a07d6a6ebd-aec3c36650.zip/node_modules/@emotion/react/dist/emotion-element-c39617d8.browser.esm.js + 2 modules
var emotion_element_c39617d8_browser_esm = __webpack_require__(71618);
// EXTERNAL MODULE: ./.yarn/__virtual__/chatie-design-system-virtual-6d39449242/0/cache/chatie-design-system-https-edc3b42f07-dc9424d6a3.zip/node_modules/chatie-design-system/dist/esm/components/icon/index.js
var icon = __webpack_require__(82740);
;// CONCATENATED MODULE: ./components/outlook/OutlookButton.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  top: 50%;\n  gap: 2px;\n  color: ",
        ";\n\n  p {\n    ",
        ";\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-top: 0px;\n  }\n  i {\n    margin-bottom: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  background-color: ",
        ";\n  padding: ",
        "px 10px;\n  border-radius: ",
        "px;\n\n  p {\n    ",
        ";\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-top: 0px;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var ArrowButtonCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(_templateObject(), theme.var.gray500, dist_esm/* Typography.body12 */.ZT.body12);
};
var ButtonCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(_templateObject1(), theme.colors.main500, dist_esm/* Spacing.xsmall */.Ki.xsmall, dist_esm/* Radius.small */.wU.small, dist_esm/* Typography.body12 */.ZT.body12, theme.var.white);
};
var OutlookButton = function(param) {
    var type = param.type, text = param.text, onClickButton = param.onClickButton;
    var theme = (0,emotion_element_c39617d8_browser_esm.u)();
    if (type === "none") {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(emotion_react_jsx_runtime_browser_esm.Fragment, {});
    }
    if (type === "arrow") {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
            css: ArrowButtonCSS,
            onClick: onClickButton && onClickButton,
            children: [
                text && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                    children: text
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(icon/* Icon */.JO, {
                    icon: icon/* ArrowRight */.ol,
                    color: theme.var.gray500,
                    size: dist_esm/* Sizes.xsmall */.u8.xsmall
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
        css: ButtonCSS,
        onClick: onClickButton,
        children: text && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
            children: text
        })
    });
};
/* harmony default export */ var outlook_OutlookButton = (OutlookButton);

;// CONCATENATED MODULE: ./components/outlook/ContentByProfileFromGallery.tsx
function ContentByProfileFromGallery_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ContentByProfileFromGallery_templateObject() {
    var data = ContentByProfileFromGallery_taggedTemplateLiteral([
        "\n  display: flex-col;\n  padding: ",
        "px 0;\n\n  h5 {\n    ",
        ";\n    line-height: 100%;\n    margin-bottom: ",
        "px;\n    padding-left: ",
        "px;\n    ",
        " {\n      padding-left: ",
        "px;\n    }\n    ",
        " {\n      padding-left: ",
        "px;\n    }\n  }\n\n  .chat-room-container {\n    padding: ",
        "px 26px !important;\n  }\n  .chat-room-header {\n    margin-left: ",
        "px;\n  }\n\n  color: ",
        ";\n"
    ]);
    ContentByProfileFromGallery_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ContentByProfileFromGallery_templateObject1() {
    var data = ContentByProfileFromGallery_taggedTemplateLiteral([
        "\n  display: flex;\n  margin-top: ",
        "px;\n  gap: ",
        "px;\n  padding: 0 ",
        "px;\n  ",
        " {\n    padding: 0 ",
        "px;\n  }\n  ",
        " {\n    padding: 0 ",
        "px;\n  }\n  .situationListContainer {\n  }\n"
    ]);
    ContentByProfileFromGallery_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = ContentByProfileFromGallery_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: initial;\n  width: ",
        " !important;\n  align-items: center;\n  gap: ",
        "px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = ContentByProfileFromGallery_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  ",
        ";\n  > p {\n    padding: 0 ",
        "px;\n    ",
        ";\n    line-height: 145%;\n    display: -webkit-box;\n    word-wrap: break-all;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = ContentByProfileFromGallery_taggedTemplateLiteral([
        "\n  height: ",
        " !important;\n  width: ",
        " !important;\n  background-color: ",
        ";\n  top: 0;\n  position: relative;\n  border-radius: ",
        ";\n  overflow: hidden;\n\n  .new-badge {\n    ",
        ";\n    display: flex;\n    align-items: center;\n    height: 16px;\n    position: absolute;\n    z-index: 1;\n    top: ",
        "px;\n    left: ",
        "px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = ContentByProfileFromGallery_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: flex-start;\n  padding: 0 4px;\n  height: 16px;\n  margin-top: ",
        "px;\n\n  p {\n    ",
        ";\n    margin-left: ",
        "px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = ContentByProfileFromGallery_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  padding-right: ",
        "px;\n  margin-bottom: ",
        "px;\n  ",
        " {\n    padding-right: ",
        "px;\n  }\n  ",
        " {\n    padding-right: ",
        "px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}

















var groupCurationCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(ContentByProfileFromGallery_templateObject(), dist_esm/* Spacing.small */.Ki.small, dist_esm/* Typography.h5 */.ZT.h5, dist_esm/* Spacing.xxsmall */.Ki.xxsmall, dist_esm/* Spacing.medium */.Ki.medium, css/* media.tablet */.BC.tablet, dist_esm/* Spacing.xlarge */.Ki.xlarge, css/* media.desktop */.BC.desktop, dist_esm/* Spacing.xxlarge */.Ki.xxlarge, dist_esm/* Spacing.small */.Ki.small, dist_esm/* Spacing.small */.Ki.small, theme.var.gray900);
};
var listContainerCSS = (0,emotion_react_browser_esm.css)(ContentByProfileFromGallery_templateObject1(), dist_esm/* Spacing.xsmall */.Ki.xsmall, dist_esm/* Spacing.small */.Ki.small, dist_esm/* Spacing.medium */.Ki.medium, css/* media.tablet */.BC.tablet, dist_esm/* Spacing.xlarge */.Ki.xlarge, css/* media.desktop */.BC.desktop, dist_esm/* Spacing.xxlarge */.Ki.xxlarge);
var situationContainerCSS = function(style) {
    return (0,emotion_react_browser_esm.css)(_templateObject2(), (style === null || style === void 0 ? void 0 : style.width) ? "".concat(style === null || style === void 0 ? void 0 : style.width, "px") : "100px", dist_esm/* Spacing.xxsmall */.Ki.xxsmall);
};
var situationInfoCSS = (0,emotion_react_browser_esm.css)(_templateObject3(), (0,css/* multilineEllipsis */.Zy)(1), dist_esm/* Spacing.xxsmall */.Ki.xxsmall, dist_esm/* Typography.body12 */.ZT.body12, (0,css/* multilineEllipsis */.Zy)(1));
var situationImgCSS = function(style) {
    return (0,emotion_react_browser_esm.css)(_templateObject4(), (style === null || style === void 0 ? void 0 : style.height) ? "".concat(style === null || style === void 0 ? void 0 : style.height, "px") : "100px", (style === null || style === void 0 ? void 0 : style.width) ? "".concat(style === null || style === void 0 ? void 0 : style.width, "px") : "100px", (style === null || style === void 0 ? void 0 : style.image_background_color) ? style === null || style === void 0 ? void 0 : style.image_background_color : null, (style === null || style === void 0 ? void 0 : style.border_radius) ? "".concat(style === null || style === void 0 ? void 0 : style.border_radius, "px") : "", dist_esm/* Typography.body11 */.ZT.body11, dist_esm/* Spacing.xxsmall */.Ki.xxsmall, dist_esm/* Spacing.xxsmall */.Ki.xxsmall);
};
var profileCSS = (0,emotion_react_browser_esm.css)(_templateObject5(), dist_esm/* Spacing.xxsmall */.Ki.xxsmall, dist_esm/* Typography.body12 */.ZT.body12, dist_esm/* Spacing.xhsmall */.Ki.xhsmall);
var headerCSS = (0,emotion_react_browser_esm.css)(_templateObject6(), dist_esm/* Spacing.medium */.Ki.medium, dist_esm/* Spacing.xhsmall */.Ki.xhsmall, css/* media.tablet */.BC.tablet, dist_esm/* Spacing.xlarge */.Ki.xlarge, css/* media.desktop */.BC.desktop, dist_esm/* Spacing.xxlarge */.Ki.xxlarge);
var ContentByProfileFromGallery = function(param) {
    var data = param.data, onClickGround = param.onClickGround, onClickProfile = param.onClickProfile, onClickSituation = param.onClickSituation, order = param.order;
    var t = (0,esm/* useTranslation */.$G)().t;
    var title = data.title, contents = data.contents, button = data.button, content_style = data.content_style;
    var type = data === null || data === void 0 ? void 0 : data.content_object_type;
    var isPaygroundType = type === "playground";
    var presetKey = "order:".concat(order, "-ContentByProfileFromGallery");
    var web = (0,webview/* useWebView */.B9)().web;
    var ref = (0,global/* useGlobalContext */.bN)(), platform = ref.platform, isCheming = ref.isCheming;
    var router = (0,next_router.useRouter)();
    var handleClickOutlookButton = function() {
        if (button.url && button.url !== "") {
            if (platform === constants/* Platform.web */.t4.web) {
                router.push(button.url);
            }
            web.openPage(button.url);
        }
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
        css: groupCurationCSS,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                css: headerCSS,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("h5", {
                        suppressHydrationWarning: true,
                        children: t(title)
                    }),
                    button && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(outlook_OutlookButton, {
                        type: button === null || button === void 0 ? void 0 : button.type,
                        text: button === null || button === void 0 ? void 0 : button.text,
                        onClickButton: handleClickOutlookButton
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(SwipableListContainer/* default */.Z, {
                className: "situationListContainer",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                    css: listContainerCSS,
                    children: contents === null || contents === void 0 ? void 0 : contents.map(function(content, idx) {
                        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
                        var hasCover = !!(content === null || content === void 0 ? void 0 : (ref = content.cover_image) === null || ref === void 0 ? void 0 : ref.key);
                        var image = hasCover ? content === null || content === void 0 ? void 0 : content.cover_image : content === null || content === void 0 ? void 0 : content.image;
                        if (!(image === null || image === void 0 ? void 0 : image.key)) {
                            return;
                        }
                        var isContain = (data === null || data === void 0 ? void 0 : data.content_object_type) === "playground" && (image === null || image === void 0 ? void 0 : (ref1 = image.attachment) === null || ref1 === void 0 ? void 0 : ref1.width) && (image === null || image === void 0 ? void 0 : (ref2 = image.attachment) === null || ref2 === void 0 ? void 0 : ref2.height) && (image === null || image === void 0 ? void 0 : (ref3 = image.attachment) === null || ref3 === void 0 ? void 0 : ref3.width) > (image === null || image === void 0 ? void 0 : (ref4 = image.attachment) === null || ref4 === void 0 ? void 0 : ref4.height);
                        var isNewSituation = (content === null || content === void 0 ? void 0 : (ref5 = content.payload) === null || ref5 === void 0 ? void 0 : ref5.released_at) && (0,date/* isBefore */.RR)(new Date(), (0,date/* addDuration */.WK)(new Date(content === null || content === void 0 ? void 0 : (ref6 = content.payload) === null || ref6 === void 0 ? void 0 : ref6.released_at), {
                            days: 3
                        })) || false;
                        var handleClick = function() {
                            if (isCheming && onClickProfile) {
                                onClickProfile(content.profile.id);
                            } else if (isPaygroundType) {
                                onClickGround(content.profile.id, content.id);
                            } else {
                                if (onClickSituation) {
                                    onClickSituation(content.id);
                                }
                            }
                        };
                        var handleClickProfile = function(e) {
                            e.stopPropagation();
                            if (!isPaygroundType && onClickProfile) {
                                onClickProfile(content.profile.id);
                            }
                        };
                        var ref11, ref12, ref13;
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(react.Fragment, {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                                css: situationContainerCSS(content_style),
                                onClick: handleClick,
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                                        css: situationImgCSS(content_style),
                                        children: [
                                            isNewSituation && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Badge/* default */.ZP, {
                                                text: "NEW",
                                                className: "new-badge",
                                                backgroundColor: isCheming ? "linear-gradient(180deg, #7F00FF, #8E2DE2)" : "linear-gradient(90deg, #04C8D0, #1590D5)",
                                                radius: dist_esm/* Radius.xsmall */.wU.xsmall,
                                                fontSize: 10
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(EFinderImage/* default */.ZP, {
                                                image: image,
                                                width: (ref11 = data === null || data === void 0 ? void 0 : (ref7 = data.content_style) === null || ref7 === void 0 ? void 0 : ref7.width) !== null && ref11 !== void 0 ? ref11 : 100,
                                                height: (ref12 = data === null || data === void 0 ? void 0 : (ref8 = data.content_style) === null || ref8 === void 0 ? void 0 : ref8.height) !== null && ref12 !== void 0 ? ref12 : 100,
                                                radius: (ref13 = data === null || data === void 0 ? void 0 : (ref9 = data.content_style) === null || ref9 === void 0 ? void 0 : ref9.border_radius) !== null && ref13 !== void 0 ? ref13 : 5,
                                                layout: "fill",
                                                objectFit: isContain ? "contain" : "cover"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                                        css: situationInfoCSS,
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                                                className: "multiline",
                                                children: t(content.title)
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                                                css: profileCSS,
                                                onClick: handleClickProfile,
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(RoundAvatar/* default */.Z, {
                                                        size: 14,
                                                        picture: (ref10 = content.profile) === null || ref10 === void 0 ? void 0 : ref10.image
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                                                        children: t(content.profile.title)
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }, content.id)
                        }, presetKey + "idx:".concat(idx));
                    })
                })
            })
        ]
    }, presetKey);
};
/* harmony default export */ var outlook_ContentByProfileFromGallery = (ContentByProfileFromGallery);

// EXTERNAL MODULE: ./components/outlook/Divider.tsx
var Divider = __webpack_require__(91708);
// EXTERNAL MODULE: ./utils/analytics.ts
var analytics = __webpack_require__(3263);
// EXTERNAL MODULE: ./utils/misc.ts + 1 modules
var misc = __webpack_require__(45874);
;// CONCATENATED MODULE: ./components/outlook/ProfileGallery.tsx
function ProfileGallery_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ProfileGallery_templateObject() {
    var data = ProfileGallery_taggedTemplateLiteral([
        "\n  display: flex-col;\n  color: ",
        ";\n\n  .listContainer {\n    gap: ",
        "px;\n  }\n\n  h5 {\n    ",
        ";\n    line-height: 100%;\n    margin-bottom: ",
        "px;\n    padding: 10px 16px;\n    ",
        " {\n      padding: 10px ",
        "px;\n    }\n    ",
        " {\n      padding: 10px ",
        "px;\n    }\n  }\n\n  .list-container {\n    display: flex;\n    padding: 0 ",
        "px;\n    ",
        " {\n      padding: 0 ",
        "px;\n    }\n    ",
        " {\n      padding: 0 ",
        "px;\n    }\n  }\n"
    ]);
    ProfileGallery_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProfileGallery_templateObject1() {
    var data = ProfileGallery_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n\n  min-width: 84px !important;\n  align-items: center;\n  text-align: center;\n  position: relative;\n  padding: 10px 0;\n\n  p {\n    ",
        ";\n    margin-top: ",
        "px;\n    color: ",
        ";\n  }\n  .new-badge {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 16px;\n    height: 16px;\n\n    position: absolute;\n    top: 10px;\n    right: 16px;\n    z-index: 1;\n\n    font-weight: 600;\n    line-height: 13.5px;\n  }\n"
    ]);
    ProfileGallery_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ProfileGallery_templateObject2() {
    var data = ProfileGallery_taggedTemplateLiteral([
        "\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  max-width: 80px;\n"
    ]);
    ProfileGallery_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}















var characterCurationCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(ProfileGallery_templateObject(), theme.var.gray900, dist_esm/* Spacing.xxsmall */.Ki.xxsmall, dist_esm/* Typography.h5 */.ZT.h5, dist_esm/* Spacing.xhsmall */.Ki.xhsmall, css/* media.tablet */.BC.tablet, dist_esm/* Spacing.xlarge */.Ki.xlarge, css/* media.desktop */.BC.desktop, dist_esm/* Spacing.xxlarge */.Ki.xxlarge, dist_esm/* Spacing.medium */.Ki.medium, css/* media.tablet */.BC.tablet, dist_esm/* Spacing.xlarge */.Ki.xlarge, css/* media.desktop */.BC.desktop, dist_esm/* Spacing.xxlarge */.Ki.xxlarge);
};
var listCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(ProfileGallery_templateObject1(), dist_esm/* Typography.body14 */.ZT.body14, dist_esm/* Spacing.small */.Ki.small, theme.var.gray800);
};
var truncateStyle = (0,emotion_react_browser_esm.css)(ProfileGallery_templateObject2());
var ProfileGallery = function(param) {
    var data = param.data;
    var ref;
    var router = (0,next_router.useRouter)();
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref1 = (0,global/* useGlobalContext */.bN)(), platform = ref1.platform, isCheming = ref1.isCheming;
    var web = (0,webview/* useWebView */.B9)().web;
    var firebase = (0,analytics/* useAnalytics */.z)().firebase;
    var _title;
    var headerTitle = (_title = data.title) !== null && _title !== void 0 ? _title : "새로운 캐릭터와 대화해 보세요";
    var handleClickProfile = function(event, profile) {
        var ref;
        event.preventDefault();
        firebase.logEvent("chatbot_click_play_curation", {
            curation_view_type: "profile_gallery"
        });
        (0,misc/* setFlow */.kB)({
            name: headerTitle
        });
        if (isCheming) {
            if (platform === constants/* Platform.web */.t4.web) {
                return router.push("/play/characters/".concat(profile === null || profile === void 0 ? void 0 : profile.id));
            }
            return web.openPage("/play/characters/".concat(profile === null || profile === void 0 ? void 0 : profile.id));
        }
        if ((ref = profile.payload.dynamic_object) === null || ref === void 0 ? void 0 : ref.chat_room_id) {
            var ref1;
            if (platform === constants/* Platform.web */.t4.web) {
                var ref2;
                router.push("/play/chat-rooms/".concat((ref2 = profile.payload.dynamic_object) === null || ref2 === void 0 ? void 0 : ref2.chat_room_id));
            }
            web.openPage("/play/chat-rooms/".concat((ref1 = profile.payload.dynamic_object) === null || ref1 === void 0 ? void 0 : ref1.chat_room_id));
            return;
        }
        if (data.profile_object_type === "character") {
            if (platform === constants/* Platform.web */.t4.web) {
                router.push("/play/characters/".concat(profile === null || profile === void 0 ? void 0 : profile.id));
            }
            web.openPage("/play/characters/".concat(profile === null || profile === void 0 ? void 0 : profile.id));
        }
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
        css: characterCurationCSS,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("h5", {
                children: t(headerTitle)
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(SwipableListContainer/* default */.Z, {
                className: "listContainer",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                    className: "list-container",
                    children: data === null || data === void 0 ? void 0 : (ref = data.profiles) === null || ref === void 0 ? void 0 : ref.map(function(profile) {
                        var ref, ref1;
                        var isNewCharacter = (profile === null || profile === void 0 ? void 0 : (ref = profile.payload) === null || ref === void 0 ? void 0 : ref.released_at) && (0,date/* isBefore */.RR)(new Date(), (0,date/* addDuration */.WK)(new Date(profile === null || profile === void 0 ? void 0 : (ref1 = profile.payload) === null || ref1 === void 0 ? void 0 : ref1.released_at), {
                            days: 3
                        })) || false;
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                            css: listCSS,
                            onClick: function(e) {
                                return handleClickProfile(e, profile);
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                                    children: [
                                        isNewCharacter && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Badge/* default */.ZP, {
                                            text: "N",
                                            radius: dist_esm/* Radius.xlarge */.wU.xlarge,
                                            backgroundColor: isCheming ? "linear-gradient(180deg, #7F00FF, #8E2DE2)" : "linear-gradient(90deg, #04C8D0, #1590D5)",
                                            className: "new-badge",
                                            fontSize: 10
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(RoundAvatar/* default */.Z, {
                                            size: 52,
                                            picture: profile.image
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                                    css: truncateStyle,
                                    children: profile.title
                                })
                            ]
                        }, profile.id);
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var outlook_ProfileGallery = (ProfileGallery);

// EXTERNAL MODULE: ./components/chat/ChatRoom.tsx
var ChatRoom = __webpack_require__(81087);
;// CONCATENATED MODULE: ./components/outlook/ProfileWithMessage.tsx
function ProfileWithMessage_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ProfileWithMessage_templateObject() {
    var data = ProfileWithMessage_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n\n  .chat-room-container {\n    padding: ",
        "px ",
        "px;\n  }\n  .chat-room-header {\n    margin-left: ",
        "px;\n  }\n"
    ]);
    ProfileWithMessage_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var ProfileWithMessage_groupCurationCSS = (0,emotion_react_browser_esm.css)(ProfileWithMessage_templateObject(), dist_esm/* Spacing.small */.Ki.small, dist_esm/* Spacing.small */.Ki.small, dist_esm/* Spacing.medium */.Ki.medium);
var ProfileWithMessage = function(param) {
    var data = param.data, onClickProfile = param.onClickProfile, onClickButton = param.onClickButton;
    var ref, ref1, ref2;
    var isNewCharacter = (data === null || data === void 0 ? void 0 : (ref = data.payload) === null || ref === void 0 ? void 0 : ref.released_at) && (0,date/* isBefore */.RR)(new Date(), (0,date/* addDuration */.WK)(new Date(data === null || data === void 0 ? void 0 : (ref1 = data.payload) === null || ref1 === void 0 ? void 0 : ref1.released_at), {
        days: 3
    })) || false;
    var chatRoomInfo = {
        characterName: data.title,
        image: data.image,
        lastMessage: ((ref2 = data.sub_title) === null || ref2 === void 0 ? void 0 : ref2.length) > 25 ? data.sub_title.slice(0, 22) + "..." : data.sub_title,
        id: data.id
    };
    var handleClickButton = function(id) {
        if (onClickButton) {
            onClickButton();
        } else {
            onClickProfile(id);
        }
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
        css: ProfileWithMessage_groupCurationCSS,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(ChatRoom/* default */.Z, {
            chatRoomInfo: chatRoomInfo,
            onClickAvatar: function() {
                return onClickProfile(data.id);
            },
            isNewCharacter: isNewCharacter,
            right: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(outlook_OutlookButton, {
                text: data.button.text,
                type: data.button.type,
                onClickButton: function() {
                    return handleClickButton(data.id);
                }
            })
        })
    });
};
/* harmony default export */ var outlook_ProfileWithMessage = (ProfileWithMessage);

;// CONCATENATED MODULE: ./components/outlook/ContentGalleryWithHeader.tsx
function ContentGalleryWithHeader_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ContentGalleryWithHeader_templateObject() {
    var data = ContentGalleryWithHeader_taggedTemplateLiteral([
        "\n  display: flex-col;\n\n  .chat-room-container {\n    padding: ",
        "px 26px !important;\n  }\n  .chat-room-header {\n    margin-left: ",
        "px;\n  }\n\n  color: ",
        ";\n"
    ]);
    ContentGalleryWithHeader_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ContentGalleryWithHeader_templateObject1() {
    var data = ContentGalleryWithHeader_taggedTemplateLiteral([
        "\n  display: flex;\n  margin-top: ",
        "px;\n  gap: ",
        "px;\n  padding: 0 ",
        "px;\n  .situationListContainer {\n  }\n"
    ]);
    ContentGalleryWithHeader_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ContentGalleryWithHeader_templateObject2() {
    var data = ContentGalleryWithHeader_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: initial;\n  width: 100px !important;\n  align-items: center;\n  gap: ",
        "px;\n"
    ]);
    ContentGalleryWithHeader_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ContentGalleryWithHeader_templateObject3() {
    var data = ContentGalleryWithHeader_taggedTemplateLiteral([
        "\n  > p {\n    padding: 0 ",
        "px;\n    ",
        ";\n    line-height: 145%;\n    display: -webkit-box;\n    word-wrap: break-all;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n  }\n"
    ]);
    ContentGalleryWithHeader_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ContentGalleryWithHeader_templateObject4() {
    var data = ContentGalleryWithHeader_taggedTemplateLiteral([
        "\n  height: 100px;\n  width: 100px;\n  top: 0;\n  position: relative;\n\n  .new-badge {\n    ",
        ";\n    display: flex;\n    align-items: center;\n    height: 16px;\n    position: absolute;\n    z-index: 1;\n    top: ",
        "px;\n    left: ",
        "px;\n  }\n"
    ]);
    ContentGalleryWithHeader_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}










var ContentGalleryWithHeader_groupCurationCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(ContentGalleryWithHeader_templateObject(), dist_esm/* Spacing.small */.Ki.small, dist_esm/* Spacing.small */.Ki.small, theme.var.gray900);
};
var ContentGalleryWithHeader_listContainerCSS = (0,emotion_react_browser_esm.css)(ContentGalleryWithHeader_templateObject1(), dist_esm/* Spacing.xsmall */.Ki.xsmall, dist_esm/* Spacing.small */.Ki.small, dist_esm/* Spacing.medium */.Ki.medium);
var ContentGalleryWithHeader_situationContainerCSS = (0,emotion_react_browser_esm.css)(ContentGalleryWithHeader_templateObject2(), dist_esm/* Spacing.xhsmall */.Ki.xhsmall);
var ContentGalleryWithHeader_situationInfoCSS = (0,emotion_react_browser_esm.css)(ContentGalleryWithHeader_templateObject3(), dist_esm/* Spacing.xxsmall */.Ki.xxsmall, dist_esm/* Typography.body12 */.ZT.body12);
var ContentGalleryWithHeader_situationImgCSS = (0,emotion_react_browser_esm.css)(ContentGalleryWithHeader_templateObject4(), dist_esm/* Typography.body11 */.ZT.body11, dist_esm/* Spacing.xxsmall */.Ki.xxsmall, dist_esm/* Spacing.xxsmall */.Ki.xxsmall);
var ContentGalleryWithHeader = function(param) {
    var data = param.data, onClickProfile = param.onClickProfile, onClickSituation = param.onClickSituation;
    var t = (0,esm/* useTranslation */.$G)().t;
    var isCheming = (0,global/* useGlobalContext */.bN)().isCheming;
    var header = data.header, contents = data.contents;
    var isSituationType = data.content_object_type === "situation";
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
        css: ContentGalleryWithHeader_groupCurationCSS,
        children: [
            isSituationType && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(outlook_ProfileWithMessage, {
                data: header,
                onClickProfile: onClickProfile
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(SwipableListContainer/* default */.Z, {
                className: "situationListContainer",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                    css: ContentGalleryWithHeader_listContainerCSS,
                    children: contents === null || contents === void 0 ? void 0 : contents.map(function(content) {
                        var ref, ref1;
                        var isNewSituation = (content === null || content === void 0 ? void 0 : (ref = content.payload) === null || ref === void 0 ? void 0 : ref.released_at) && (0,date/* isBefore */.RR)(new Date(), (0,date/* addDuration */.WK)(new Date(content === null || content === void 0 ? void 0 : (ref1 = content.payload) === null || ref1 === void 0 ? void 0 : ref1.released_at), {
                            days: 3
                        })) || false;
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                            css: ContentGalleryWithHeader_situationContainerCSS,
                            onClick: function(e) {
                                if (isCheming) {
                                    return onClickProfile && onClickProfile(header.id);
                                }
                                onClickSituation && onClickSituation(e, content);
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                                    css: ContentGalleryWithHeader_situationImgCSS,
                                    children: [
                                        isNewSituation && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Badge/* default */.ZP, {
                                            text: "NEW",
                                            className: "new-badge",
                                            backgroundColor: isCheming ? "linear-gradient(180deg, #7F00FF, #8E2DE2)" : "linear-gradient(90deg, #04C8D0, #1590D5)",
                                            radius: dist_esm/* Radius.xsmall */.wU.xsmall,
                                            fontSize: 10
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(EFinderImage/* default */.ZP, {
                                            image: content.image,
                                            h: 100,
                                            radius: 5,
                                            layout: "responsive"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                    css: ContentGalleryWithHeader_situationInfoCSS,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                                        className: "multiline",
                                        children: t(content.title)
                                    })
                                })
                            ]
                        }, content.id);
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var outlook_ContentGalleryWithHeader = (ContentGalleryWithHeader);

;// CONCATENATED MODULE: ./components/outlook/PlacardBanner.tsx
function PlacardBanner_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function PlacardBanner_templateObject() {
    var data = PlacardBanner_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: ",
        "px;\n  background-color: ",
        ";\n  overflow: hidden;\n  position: relative;\n\n  > img {\n    width: 100%;\n    height: ",
        "px;\n    overflow: hidden;\n    position: relative;\n  }\n\n  .bannerText {\n    ",
        ";\n    color: ",
        ";\n    font-weight: 600;\n    z-index: 3;\n  }\n"
    ]);
    PlacardBanner_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var containerCSS = function(data) {
    return (0,emotion_react_browser_esm.css)(PlacardBanner_templateObject(), data.height, data.background_color, data.height, dist_esm/* Typography.h6 */.ZT.h6, data.font_color);
};
var PlaCardBanner = function(param) {
    var data = param.data;
    var ref, ref1, ref2, ref3;
    var router = (0,next_router.useRouter)();
    var web = (0,webview/* useWebView */.B9)().web;
    var platform = (0,global/* useGlobalContext */.bN)().platform;
    var handleClickCard = function() {
        if (data.url !== "") {
            if (platform === constants/* Platform.web */.t4.web) {
                router.push(data.url);
            }
            web.openUrl(data.url);
        }
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
        onClick: handleClickCard,
        css: containerCSS(data),
        children: [
            (data === null || data === void 0 ? void 0 : (ref = data.banner) === null || ref === void 0 ? void 0 : ref.image) && (data === null || data === void 0 ? void 0 : (ref1 = data.banner) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.image) === null || ref2 === void 0 ? void 0 : ref2.key) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(EFinderImage/* default */.ZP, {
                image: data === null || data === void 0 ? void 0 : (ref3 = data.banner) === null || ref3 === void 0 ? void 0 : ref3.image
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                className: "bannerText",
                children: data.title
            })
        ]
    });
};
/* harmony default export */ var PlacardBanner = (PlaCardBanner);

// EXTERNAL MODULE: ./components/common/SvgIcon.tsx
var SvgIcon = __webpack_require__(34368);
// EXTERNAL MODULE: ./public/icons/ic_play.svg
var ic_play = __webpack_require__(88797);
// EXTERNAL MODULE: ./public/icons/profile_32.svg
var profile_32 = __webpack_require__(42079);
// EXTERNAL MODULE: ./utils/chat.ts
var chat = __webpack_require__(42127);
;// CONCATENATED MODULE: ./components/outlook/ProfileByChoiceFromGallery.tsx
/* eslint-disable react/no-unescaped-entities */ function ProfileByChoiceFromGallery_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ProfileByChoiceFromGallery_templateObject() {
    var data = ProfileByChoiceFromGallery_taggedTemplateLiteral([
        "\n  .header {\n    display: flex;\n    justify-content: space-between;\n    padding: 10px ",
        "px 0;\n    ",
        " {\n      padding: 10px ",
        "px 0;\n    }\n    ",
        " {\n      padding: 10px ",
        "px 0;\n    }\n  }\n  .gridContainer {\n    display: grid;\n    grid-auto-flow: column;\n    column-gap: ",
        "px;\n    row-gap: 10px;\n    padding: 6px 16px ",
        "px;\n    margin-top: ",
        "px;\n    ",
        " {\n      padding: 6px ",
        "px ",
        "px;\n    }\n    ",
        " {\n      padding: 6px ",
        "px ",
        "px;\n    }\n  }\n\n  .with-quotes {\n    position: relative;\n  }\n  .with-quotes::after,\n  .with-quotes::before {\n    content: '\"';\n  }\n  .with-quotes::after {\n    position: absolute;\n    right: 0px;\n    top: 0px;\n    content: '\"';\n    z-index: 9;\n  }\n"
    ]);
    ProfileByChoiceFromGallery_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProfileByChoiceFromGallery_templateObject1() {
    var data = ProfileByChoiceFromGallery_taggedTemplateLiteral([
        "\n  display: flex;\n  flex: 1;\n  width: 100%;\n\n  .imageContainer {\n    width: 36px;\n    height: 36px;\n    border-radius: ",
        "px;\n    margin-right: ",
        "px;\n    position: relative;\n    overflow: hidden;\n  }\n  .image {\n    width: 36px;\n    height: 36px;\n    background-color: ",
        ";\n    border-radius: ",
        "px;\n    margin-right: ",
        "px;\n  }\n  .infoContainer {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    width: 100%;\n    overflow: hidden;\n  }\n  .name {\n    ",
        ";\n  }\n  .info {\n    ",
        ";\n    color: ",
        ";\n    margin-top: ",
        "px;\n    display: flex;\n  }\n"
    ]);
    ProfileByChoiceFromGallery_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ProfileByChoiceFromGallery_templateObject2() {
    var data = ProfileByChoiceFromGallery_taggedTemplateLiteral([
        "\n  width: 304px;\n  display: flex;\n  flex-direction: column;\n  padding: ",
        "px;\n  border-radius: ",
        "px;\n  box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, 0.05);\n"
    ]);
    ProfileByChoiceFromGallery_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ProfileByChoiceFromGallery_templateObject3() {
    var data = ProfileByChoiceFromGallery_taggedTemplateLiteral([
        "\n  text-align: start;\n  margin-top: ",
        "px;\n  min-height: 36px;\n  max-height: 36px;\n\n  span {\n    line-height: 145%;\n    display: inline-block;\n  }\n"
    ]);
    ProfileByChoiceFromGallery_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ProfileByChoiceFromGallery_templateObject4() {
    var data = ProfileByChoiceFromGallery_taggedTemplateLiteral([
        "\n  padding-bottom: 14px;\n\n  .choice-background-container {\n    margin-top: ",
        "px;\n    width: 280px;\n    height: 60px;\n  }\n\n  .choice-container {\n    display: flex;\n    width: 100%;\n    height: 100%;\n    padding: 14px ",
        "px;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n    border-radius: 5px;\n    border: 1px solid ",
        ";\n    background: ",
        ";\n    gap: ",
        "px;\n  }\n"
    ]);
    ProfileByChoiceFromGallery_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ProfileByChoiceFromGallery_templateObject5() {
    var data = ProfileByChoiceFromGallery_taggedTemplateLiteral([
        "\n      max-width: ",
        "px;\n      padding-right: 5px;\n      color: ",
        ";\n      overflow: hidden;\n      white-space: nowrap;\n      text-overflow: ellipsis;\n      word-wrap: break-word;\n      word-break: break-all;\n\n      ",
        ";\n    "
    ]);
    ProfileByChoiceFromGallery_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}













var ProfileByChoiceFromGallery_containerCSS = (0,emotion_react_browser_esm.css)(ProfileByChoiceFromGallery_templateObject(), dist_esm/* Spacing.medium */.Ki.medium, css/* media.tablet */.BC.tablet, dist_esm/* Spacing.xlarge */.Ki.xlarge, css/* media.desktop */.BC.desktop, dist_esm/* Spacing.xxlarge */.Ki.xxlarge, dist_esm/* Spacing.xsmall */.Ki.xsmall, dist_esm/* Spacing.large */.Ki.large, dist_esm/* Spacing.medium */.Ki.medium, css/* media.tablet */.BC.tablet, dist_esm/* Spacing.xlarge */.Ki.xlarge, dist_esm/* Spacing.large */.Ki.large, css/* media.desktop */.BC.desktop, dist_esm/* Spacing.xxlarge */.Ki.xxlarge, dist_esm/* Spacing.large */.Ki.large);
var infoContainerCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(ProfileByChoiceFromGallery_templateObject1(), dist_esm/* Radius.small */.wU.small, dist_esm/* Spacing.small */.Ki.small, theme.var.gray200, dist_esm/* Radius.small */.wU.small, dist_esm/* Spacing.small */.Ki.small, dist_esm/* Typography.body12 */.ZT.body12, dist_esm/* Typography.body11 */.ZT.body11, theme.var.gray500, dist_esm/* Spacing.xhsmall */.Ki.xhsmall);
};
var cardContainerCSS = (0,emotion_react_browser_esm.css)(ProfileByChoiceFromGallery_templateObject2(), dist_esm/* Spacing.small */.Ki.small, dist_esm/* Radius.small */.wU.small);
var startMessageContainer = (0,emotion_react_browser_esm.css)(ProfileByChoiceFromGallery_templateObject3(), dist_esm/* Spacing.small */.Ki.small);
var choicesContainer = function(theme) {
    return (0,emotion_react_browser_esm.css)(ProfileByChoiceFromGallery_templateObject4(), dist_esm/* Spacing.small */.Ki.small, dist_esm/* Spacing.small */.Ki.small, theme.var.gray200, theme.var.gray100, dist_esm/* Spacing.xsmall */.Ki.xsmall);
};
var choiceMessageCss = function(isParagraph) {
    var maxWidth = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 256;
    return function(theme) {
        return (0,emotion_react_browser_esm.css)(ProfileByChoiceFromGallery_templateObject5(), maxWidth - 5, isParagraph ? theme.var.gray500 : theme.var.gray900, dist_esm/* Typography.body12 */.ZT.body12);
    };
};
var ProfileByChoiceFromGallery = function(param) {
    var data = param.data, onClickGroundCharacrer = param.onClickGroundCharacrer, order = param.order, onClickChoice = param.onClickChoice;
    var t = (0,esm/* useTranslation */.$G)().t;
    var isCheming = (0,global/* useGlobalContext */.bN)().isCheming;
    var title = data.title, profiles = data.profiles, choice_count = data.choice_count;
    var presetKey = order + "ProfileByChoiceFromGallery";
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
        css: ProfileByChoiceFromGallery_containerCSS,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                className: "header",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("h5", {
                    suppressHydrationWarning: true,
                    children: t(title)
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(SwipableListContainer/* default */.Z, {
                className: "galleryCardListContainer",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                    className: "gridContainer",
                    children: profiles === null || profiles === void 0 ? void 0 : profiles.map(function(item, idx) {
                        var startMessages = item.payload.dynamic_object.situation.start_messages;
                        var _message_count;
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                            css: cardContainerCSS,
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                                    css: infoContainerCSS,
                                    onClick: function() {
                                        return onClickGroundCharacrer ? onClickGroundCharacrer(item.id) : undefined;
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                            className: "imageContainer",
                                            children: item.image && item.image.key ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(EFinderImage/* default */.ZP, {
                                                image: item.image,
                                                h: EFinderImage/* EFinderImageSizes.avatar */.ny.avatar,
                                                alt: "profile_img"
                                            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                                className: "image",
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(SvgIcon/* default */.Z, {
                                                    icon: profile_32/* default */.Z,
                                                    d: 36
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                                            className: "infoContainer",
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("h6", {
                                                    className: "name",
                                                    children: item.title
                                                }),
                                                !isCheming && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("p", {
                                                    className: "info",
                                                    children: [
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(SvgIcon/* default */.Z, {
                                                            icon: ic_play/* default */.Z
                                                        }),
                                                        (0,chat/* formatNumberMillion */.OQ)((_message_count = item.payload.dynamic_object.message_count) !== null && _message_count !== void 0 ? _message_count : 0)
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                    className: "discription",
                                    css: startMessageContainer,
                                    children: Array.from({
                                        length: 2
                                    }, function(_, startMessageIndex) {
                                        var innerIdx = startMessageIndex === 0 ? (startMessages === null || startMessages === void 0 ? void 0 : startMessages.length) - 2 : (startMessages === null || startMessages === void 0 ? void 0 : startMessages.length) - 1;
                                        var hasContent = !!startMessages[innerIdx];
                                        var message = hasContent ? startMessages[innerIdx] : {
                                            content: "",
                                            type: "character"
                                        };
                                        var isCharacrer = (message === null || message === void 0 ? void 0 : message.type) !== "narration";
                                        var content = message === null || message === void 0 ? void 0 : message.content;
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(react.Fragment, {
                                            children: hasContent && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(react.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("span", {
                                                        css: choiceMessageCss(!isCharacrer, 280),
                                                        className: isCharacrer ? "with-quotes" : "",
                                                        children: t(isCharacrer ? content : content.replaceAll("*", ""))
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("br", {})
                                                ]
                                            })
                                        }, "order:".concat(order, "-idx:").concat(idx, "-startMessageIndex:").concat(startMessageIndex, "-message"));
                                    })
                                }, presetKey + "startMessageContainer" + "idx:"),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                    css: choicesContainer,
                                    children: Array.from({
                                        length: choice_count
                                    }, function(_, index) {
                                        var ref, ref1;
                                        var hasChoice = !!item.choices[index];
                                        var contents = item.choices ? (ref = item.choices[index]) === null || ref === void 0 ? void 0 : (ref1 = ref.content) === null || ref1 === void 0 ? void 0 : ref1.split("\n") : [];
                                        var length = (contents === null || contents === void 0 ? void 0 : contents.length) >= 2 ? 2 : contents === null || contents === void 0 ? void 0 : contents.length;
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                            className: "choice-background-container",
                                            onClick: function() {
                                                return onClickChoice ? onClickChoice(index, item.payload.dynamic_object.situation.id) : undefined;
                                            },
                                            children: hasChoice && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                                className: "choice-container",
                                                children: Array.from({
                                                    length: length
                                                }, function(_, contentIndex) {
                                                    var hasContent = !!contents[contentIndex];
                                                    var content = hasContent ? contents[contentIndex] : "";
                                                    var isParagraph = content === null || content === void 0 ? void 0 : content.includes("*");
                                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                                                        css: choiceMessageCss(isParagraph),
                                                        className: !isParagraph ? "with-quotes" : "",
                                                        children: t(isParagraph ? content === null || content === void 0 ? void 0 : content.replaceAll("*", "") : content === null || content === void 0 ? void 0 : content.replaceAll('"', ""))
                                                    }, "order:" + order + "startMessageContainer" + "idx:" + contentIndex + "innerIdx : " + index);
                                                })
                                            })
                                        }, presetKey + "choicesContainer" + "idx:" + index);
                                    })
                                })
                            ]
                        }, "info_list_".concat(idx));
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var outlook_ProfileByChoiceFromGallery = (ProfileByChoiceFromGallery);

// EXTERNAL MODULE: ./components/layout/Pad.tsx
var Pad = __webpack_require__(95833);
;// CONCATENATED MODULE: ./components/characters/ProfileInfoGalleryCard.tsx
function ProfileInfoGalleryCard_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ProfileInfoGalleryCard_templateObject() {
    var data = ProfileInfoGalleryCard_taggedTemplateLiteral([
        "\n    display: flex;\n    flex-direction: column;\n    width: ",
        "px;\n    height: ",
        "px;\n    border-radius: ",
        "px;\n    box-shadow: 3px -2px 20px 3px #0000000d;\n    overflow: hidden;\n\n    .imageContainer {\n      height: ",
        "px;\n      background-color: ",
        ";\n      position: relative;\n\n      .gradient {\n        position: absolute;\n        width: 100%;\n        height: 40px;\n        top: 0;\n        z-index: 1;\n        ",
        "\n      }\n\n      .icon-btn {\n        position: absolute;\n        top: 10px;\n        right: 10px;\n        z-index: 10;\n        padding: 0;\n        margin: 0;\n      }\n\n      .playCount {\n        position: absolute;\n        width: 100%;\n        top: 0;\n        display: flex;\n        gap: ",
        "px;\n        padding: 10px;\n        ",
        ";\n        color: ",
        ";\n        z-index: 10;\n\n        svg path {\n          fill: currentcolor;\n        }\n      }\n\n      .image {\n        width: 100%;\n        height: 126px;\n        background-color: ",
        ";\n      }\n    }\n\n    .info {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      padding: 10px 9px ",
        "px;\n\n      .name {\n        ",
        ";\n        ",
        "\n      }\n      .age {\n        ",
        ";\n        margin-top: ",
        "px;\n        margin-bottom: ",
        "px;\n        color: ",
        ";\n        ",
        "\n      }\n      .desc {\n        ",
        ";\n        font-weight: 600;\n        ",
        "\n      }\n    }\n  "
    ]);
    ProfileInfoGalleryCard_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProfileInfoGalleryCard_templateObject1() {
    var data = ProfileInfoGalleryCard_taggedTemplateLiteral([
        "\n    display: flex;\n    align-items: center;\n    position: absolute;\n    right: 7px;\n    top: 7px;\n    font-weight: 600;\n    font-color: ",
        ";\n    background: ",
        ";\n    z-index: 11;\n  "
    ]);
    ProfileInfoGalleryCard_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}












var ProfileInfoGalleryCard_cardContainerCSS = function(size) {
    return function(theme) {
        return (0,emotion_react_browser_esm.css)(ProfileInfoGalleryCard_templateObject(), size.width, size.height, dist_esm/* Radius.small */.wU.small, size.imageHeight, theme.var.white, (0,css/* linearGradient */.bC)("top", "rgba(255, 255, 255, 0)", "rgba(0, 0, 0, 0.2)"), dist_esm/* Spacing.xxxsmall */.Ki.xxxsmall, dist_esm/* Typography.body11 */.ZT.body11, theme.var.white, theme.var.gray200, dist_esm/* Spacing.medium */.Ki.medium, dist_esm/* Typography.body12 */.ZT.body12, (0,css/* multilineEllipsis */.Zy)(1), size.infoFontSize === 11 ? dist_esm/* Typography.body11 */.ZT.body11 : dist_esm/* Typography.body12 */.ZT.body12, dist_esm/* Spacing.xxsmall */.Ki.xxsmall, dist_esm/* Spacing.xsmall */.Ki.xsmall, theme.var.gray500, (0,css/* multilineEllipsis */.Zy)(1), dist_esm/* Typography.body12 */.ZT.body12, (0,css/* multilineEllipsis */.Zy)(1));
    };
};
var badgeCSS = function(isToday) {
    return function(theme) {
        return (0,emotion_react_browser_esm.css)(ProfileInfoGalleryCard_templateObject1(), theme.var.white, isToday ? "var(\n          --promotion-gra,\n          linear-gradient(57deg, #ff07f5 19.7%, #ed0064 80.3%)\n        )" : theme.colors.honorGra);
    };
};
var ProfileInfoGalleryCardSize = {
    w166: {
        width: 166,
        height: 216,
        imageHeight: 140,
        infoFontSize: 12
    },
    w128: {
        width: 128,
        height: 199,
        imageHeight: 126,
        infoFontSize: 11
    }
};
var TODAY_FREE = "오늘만 무료!";
var ProfileInfoGalleryCard = function(param) {
    var data = param.data, _size = param.size, size = _size === void 0 ? "w128" : _size, hanelOnClickCard = param.hanelOnClickCard;
    var ref;
    var isCheming = (0,global/* useGlobalContext */.bN)().isCheming;
    var id = data.id, image = data.image, title = data.title, information = data.information, payload = data.payload, badge = data.badge;
    var defaultProfileImgSizeMapper = {
        w128: 128,
        w166: 166
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
        css: ProfileInfoGalleryCard_cardContainerCSS(ProfileInfoGalleryCardSize[size]),
        onClick: function() {
            return hanelOnClickCard && hanelOnClickCard(id);
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                className: "imageContainer",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Pad/* default */.Z, {
                        className: "gradient"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                        children: !isCheming && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                            className: "playCount",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(SvgIcon/* default */.Z, {
                                    icon: ic_play/* default */.Z
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                                    children: (0,chat/* formatNumberMillion */.OQ)(((ref = payload.dynamic_object) === null || ref === void 0 ? void 0 : ref.message_count) || 0)
                                })
                            ]
                        })
                    }),
                    image && image.key ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(EFinderImage/* default */.ZP, {
                                image: image,
                                alt: "profile_img"
                            }),
                            badge && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Badge/* default */.ZP, {
                                text: badge,
                                css: badgeCSS(badge === TODAY_FREE)
                            })
                        ]
                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                        className: "image",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(SvgIcon/* default */.Z, {
                            icon: profile_32/* default */.Z,
                            d: defaultProfileImgSizeMapper[size]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                className: "info",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("h6", {
                        className: "name",
                        children: title
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                        className: "age",
                        children: information.sub_title
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                        className: "desc",
                        children: information.description
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var characters_ProfileInfoGalleryCard = (ProfileInfoGalleryCard);

;// CONCATENATED MODULE: ./components/outlook/ProfileByInfoCardFormGallery.tsx
function ProfileByInfoCardFormGallery_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ProfileByInfoCardFormGallery_templateObject() {
    var data = ProfileByInfoCardFormGallery_taggedTemplateLiteral([
        "\n  .header {\n    display: flex;\n    justify-content: space-between;\n    padding: 10px ",
        "px 0;\n    ",
        " {\n      padding: 10px ",
        "px 0;\n    }\n    ",
        " {\n      padding: 10px ",
        "px 0;\n    }\n  }\n\n  .cardListContainer {\n    display: flex;\n    margin-top: ",
        "px;\n    gap: 10px;\n    padding: 0 ",
        "px;\n    padding-bottom: 10px;\n    ",
        " {\n      padding: 0 ",
        "px;\n      padding-bottom: 10px;\n    }\n    ",
        " {\n      padding: 0 ",
        "px;\n      padding-bottom: 10px;\n    }\n  }\n"
    ]);
    ProfileByInfoCardFormGallery_templateObject = function _templateObject() {
        return data;
    };
    return data;
}













var ProfileByInfoCardFormGallery_containerCSS = function() {
    return (0,emotion_react_browser_esm.css)(ProfileByInfoCardFormGallery_templateObject(), dist_esm/* Spacing.medium */.Ki.medium, css/* media.tablet */.BC.tablet, dist_esm/* Spacing.xlarge */.Ki.xlarge, css/* media.desktop */.BC.desktop, dist_esm/* Spacing.xxlarge */.Ki.xxlarge, dist_esm/* Spacing.large */.Ki.large, dist_esm/* Spacing.medium */.Ki.medium, css/* media.tablet */.BC.tablet, dist_esm/* Spacing.xlarge */.Ki.xlarge, css/* media.desktop */.BC.desktop, dist_esm/* Spacing.xxlarge */.Ki.xxlarge);
};
var ProfileByInfoCardFormGallery = function(param) {
    var data = param.data, componentKey = param.componentKey, onClickCard = param.onClickCard, onClickProfile = param.onClickProfile;
    var t = (0,esm/* useTranslation */.$G)().t;
    var title = data.title, profiles = data.profiles, button = data.button;
    var web = (0,webview/* useWebView */.B9)().web;
    var ref = (0,global/* useGlobalContext */.bN)(), platform = ref.platform, isCheming = ref.isCheming;
    var router = (0,next_router.useRouter)();
    var handleClickOutlookButton = function() {
        if (button.url && button.url !== "") {
            if (platform === constants/* Platform.web */.t4.web) {
                router.push(button.url);
            }
            web.openPage(button.url);
        } else {
            var url = "/play/characters/".concat((0,misc/* toQueryString */.UK)({
                componentKey: componentKey
            }));
            if (platform === constants/* Platform.web */.t4.web) {
                router.push(url);
            }
            web.openPage(url);
        }
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
        css: ProfileByInfoCardFormGallery_containerCSS,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                className: "header",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("h5", {
                        suppressHydrationWarning: true,
                        children: t(title)
                    }),
                    button && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(outlook_OutlookButton, {
                        type: button.type,
                        text: button.text,
                        onClickButton: handleClickOutlookButton
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(SwipableListContainer/* default */.Z, {
                className: "galleryCardListContainer",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                    className: "cardListContainer",
                    children: profiles.map(function(item) {
                        var ref, ref1;
                        /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm.jsx)(characters_ProfileInfoGalleryCard, {
                            data: item,
                            size: "w128",
                            hanelOnClickCard: isCheming || (item === null || item === void 0 ? void 0 : (ref = item.payload) === null || ref === void 0 ? void 0 : (ref1 = ref.dynamic_object) === null || ref1 === void 0 ? void 0 : ref1.type) === "official" ? onClickProfile : onClickCard
                        }, "profile_".concat(item.id));
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var outlook_ProfileByInfoCardFormGallery = (ProfileByInfoCardFormGallery);

;// CONCATENATED MODULE: ./components/outlook/ProfileByInfoPlacardFormGallery.tsx
function ProfileByInfoPlacardFormGallery_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ProfileByInfoPlacardFormGallery_templateObject() {
    var data = ProfileByInfoPlacardFormGallery_taggedTemplateLiteral([
        "\n  .header {\n    display: flex;\n    justify-content: space-between;\n    padding: 10px ",
        "px 0;\n    ",
        " {\n      padding: 10px ",
        "px 0;\n    }\n    ",
        " {\n      padding: 10px ",
        "px 0;\n    }\n  }\n  .gridContainer {\n    display: grid;\n    grid-auto-flow: column;\n    grid-template-rows: repeat(",
        ", 1fr);\n    column-gap: ",
        "px;\n    row-gap: 10px;\n    padding: 6px 16px ",
        "px;\n    margin-top: ",
        "px;\n    ",
        " {\n      padding: 6px ",
        "px ",
        "px;\n    }\n    ",
        " {\n      padding: 6px ",
        "px ",
        "px;\n    }\n  }\n"
    ]);
    ProfileByInfoPlacardFormGallery_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProfileByInfoPlacardFormGallery_templateObject1() {
    var data = ProfileByInfoPlacardFormGallery_taggedTemplateLiteral([
        "\n  display: flex;\n  flex: 1;\n  width: 300px;\n  padding: ",
        "px;\n  border-radius: ",
        "px;\n\n  box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, 0.05);\n\n  .imageContainer {\n    width: 50px;\n    height: 50px;\n    border-radius: ",
        "px;\n    margin-right: ",
        "px;\n    position: relative;\n    overflow: hidden;\n  }\n  .image {\n    width: 50px;\n    height: 50px;\n    background-color: ",
        ";\n    border-radius: ",
        "px;\n    margin-right: ",
        "px;\n  }\n  .infoContainer {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    width: 100%;\n    overflow: hidden;\n  }\n  .name {\n    ",
        ";\n  }\n  .info {\n    ",
        ";\n    color: ",
        ";\n    margin-top: ",
        "px;\n    margin-bottom: ",
        "px;\n  }\n  .desc {\n    width: 100%;\n    ",
        ";\n    font-size: 12px;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n  }\n"
    ]);
    ProfileByInfoPlacardFormGallery_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}















var ProfileByInfoPlacardFormGallery_containerCSS = function(rows) {
    return (0,emotion_react_browser_esm.css)(ProfileByInfoPlacardFormGallery_templateObject(), dist_esm/* Spacing.medium */.Ki.medium, css/* media.tablet */.BC.tablet, dist_esm/* Spacing.xlarge */.Ki.xlarge, css/* media.desktop */.BC.desktop, dist_esm/* Spacing.xxlarge */.Ki.xxlarge, rows, dist_esm/* Spacing.xsmall */.Ki.xsmall, dist_esm/* Spacing.large */.Ki.large, dist_esm/* Spacing.medium */.Ki.medium, css/* media.tablet */.BC.tablet, dist_esm/* Spacing.xlarge */.Ki.xlarge, dist_esm/* Spacing.large */.Ki.large, css/* media.desktop */.BC.desktop, dist_esm/* Spacing.xxlarge */.Ki.xxlarge, dist_esm/* Spacing.large */.Ki.large);
};
var ProfileByInfoPlacardFormGallery_cardContainerCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(ProfileByInfoPlacardFormGallery_templateObject1(), dist_esm/* Spacing.small */.Ki.small, dist_esm/* Radius.small */.wU.small, dist_esm/* Radius.small */.wU.small, dist_esm/* Spacing.small */.Ki.small, theme.var.gray200, dist_esm/* Radius.small */.wU.small, dist_esm/* Spacing.small */.Ki.small, dist_esm/* Typography.body12 */.ZT.body12, dist_esm/* Typography.body11 */.ZT.body11, theme.var.gray500, dist_esm/* Spacing.xxsmall */.Ki.xxsmall, dist_esm/* Spacing.xsmall */.Ki.xsmall, dist_esm/* Typography.h6 */.ZT.h6);
};
var ProfileByInfoPlacardFormGallery = function(param) {
    var data = param.data, componentKey = param.componentKey, onClickCard = param.onClickCard, onClickProfile = param.onClickProfile;
    var t = (0,esm/* useTranslation */.$G)().t;
    var title = data.title, row_count = data.row_count, profiles = data.profiles, button = data.button;
    var web = (0,webview/* useWebView */.B9)().web;
    var ref = (0,global/* useGlobalContext */.bN)(), platform = ref.platform, isCheming = ref.isCheming;
    var router = (0,next_router.useRouter)();
    var handleClickOutlookButton = function() {
        if (button.url && button.url !== "") {
            if (platform === constants/* Platform.web */.t4.web) {
                router.push(button.url);
            }
            web.openPage(button.url);
        } else {
            var url = "/play/characters/".concat((0,misc/* toQueryString */.UK)({
                componentKey: componentKey
            }));
            if (platform === constants/* Platform.web */.t4.web) {
                router.push(url);
            }
            web.openPage(url);
        }
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
        css: ProfileByInfoPlacardFormGallery_containerCSS(row_count),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                className: "header",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("h5", {
                        suppressHydrationWarning: true,
                        children: t(title)
                    }),
                    button && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(outlook_OutlookButton, {
                        type: button.type,
                        text: button.text,
                        onClickButton: handleClickOutlookButton
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(SwipableListContainer/* default */.Z, {
                className: "galleryCardListContainer",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                    className: "gridContainer",
                    children: profiles.map(function(item, idx) {
                        /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                            css: ProfileByInfoPlacardFormGallery_cardContainerCSS,
                            onClick: function() {
                                var ref, ref1;
                                return isCheming || (item === null || item === void 0 ? void 0 : (ref = item.payload) === null || ref === void 0 ? void 0 : (ref1 = ref.dynamic_object) === null || ref1 === void 0 ? void 0 : ref1.type) === "official" ? onClickProfile && onClickProfile(item.id) : onClickCard && onClickCard(item.id);
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                    className: "imageContainer",
                                    children: item.image && item.image.key ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(EFinderImage/* default */.ZP, {
                                        image: item.image,
                                        h: EFinderImage/* EFinderImageSizes.avatar */.ny.avatar,
                                        alt: "profile_img"
                                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                        className: "image",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(SvgIcon/* default */.Z, {
                                            icon: profile_32/* default */.Z,
                                            d: 50
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                                    className: "infoContainer",
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("h6", {
                                            className: "name",
                                            children: item.title
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                                            className: "info",
                                            children: item.information.sub_title
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                                            className: "desc",
                                            children: item.information.description
                                        })
                                    ]
                                })
                            ]
                        }, "info_list_".concat(idx));
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var outlook_ProfileByInfoPlacardFormGallery = (ProfileByInfoPlacardFormGallery);

;// CONCATENATED MODULE: ./components/outlook/ProfileByInfoPlacardFormList.tsx
function ProfileByInfoPlacardFormList_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ProfileByInfoPlacardFormList_templateObject() {
    var data = ProfileByInfoPlacardFormList_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  padding: 10px ",
        "px 0;\n  ",
        " {\n    padding: 10px ",
        "px 0;\n  }\n  ",
        " {\n    padding: 10px ",
        "px 0;\n  }\n\n  .header {\n    display: flex;\n    justify-content: space-between;\n    padding: 10px 0;\n    margin-bottom: ",
        "px;\n  }\n  .listContainer {\n    display: flex;\n    flex-direction: column;\n    gap: ",
        "px;\n  }\n"
    ]);
    ProfileByInfoPlacardFormList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProfileByInfoPlacardFormList_templateObject1() {
    var data = ProfileByInfoPlacardFormList_taggedTemplateLiteral([
        "\n  display: flex;\n  flex: 1;\n  padding: ",
        "px;\n  border-radius: ",
        "px;\n\n  box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, 0.05);\n\n  .imageContainer {\n    width: 36px;\n    height: 36px;\n    border-radius: ",
        "px;\n    margin-right: ",
        "px;\n    position: relative;\n    overflow: hidden;\n  }\n\n  .image {\n    background-color: ",
        ";\n    width: 36px;\n    height: 36px;\n    border-radius: ",
        "px;\n    margin-right: ",
        "px;\n    overflow: hidden;\n  }\n  .infoContainer {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    flex: 1;\n    width: 100%;\n    overflow: hidden;\n  }\n  .name {\n    ",
        ";\n    margin-bottom: ",
        "px;\n  }\n  .playCount {\n    display: flex;\n    gap: ",
        "px;\n    ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    ProfileByInfoPlacardFormList_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}













var ProfileByInfoPlacardFormList_containerCSS = function() {
    return (0,emotion_react_browser_esm.css)(ProfileByInfoPlacardFormList_templateObject(), dist_esm/* Spacing.medium */.Ki.medium, css/* media.tablet */.BC.tablet, dist_esm/* Spacing.xlarge */.Ki.xlarge, css/* media.desktop */.BC.desktop, dist_esm/* Spacing.xxlarge */.Ki.xxlarge, dist_esm/* Spacing.xhsmall */.Ki.xhsmall, dist_esm/* Spacing.xsmall */.Ki.xsmall);
};
var ProfileByInfoPlacardFormList_cardContainerCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(ProfileByInfoPlacardFormList_templateObject1(), dist_esm/* Spacing.small */.Ki.small, dist_esm/* Radius.small */.wU.small, dist_esm/* Radius.small */.wU.small, dist_esm/* Spacing.small */.Ki.small, theme.var.gray200, dist_esm/* Radius.small */.wU.small, dist_esm/* Spacing.small */.Ki.small, dist_esm/* Typography.body12 */.ZT.body12, dist_esm/* Spacing.xhsmall */.Ki.xhsmall, dist_esm/* Spacing.xxxsmall */.Ki.xxxsmall, dist_esm/* Typography.body11 */.ZT.body11, theme.var.gray400);
};
var ProfileByInfoPlacardFormList = function(param) {
    var data = param.data, onClickSituationById = param.onClickSituationById;
    var t = (0,esm/* useTranslation */.$G)().t;
    var title = data.title, profiles = data.profiles;
    var web = (0,webview/* useWebView */.B9)().web;
    var ref = (0,global/* useGlobalContext */.bN)(), platform = ref.platform, isCheming = ref.isCheming;
    var theme = (0,emotion_element_c39617d8_browser_esm.u)();
    var router = (0,next_router.useRouter)();
    var handleNavigateCharacter = function(e, id) {
        e.stopPropagation();
        if (platform === constants/* Platform.web */.t4.web) {
            router.push("/play/characters/".concat(id));
        } else {
            web.openPage("/play/characters/".concat(id));
        }
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
        css: ProfileByInfoPlacardFormList_containerCSS,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                className: "header",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("h5", {
                    suppressHydrationWarning: true,
                    children: t(title)
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                className: "listContainer",
                children: profiles.map(function(item, idx) {
                    var ref;
                    /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                        css: ProfileByInfoPlacardFormList_cardContainerCSS,
                        onClick: function(e) {
                            var ref, ref1, ref2, ref3;
                            if (isCheming) {
                                return handleNavigateCharacter(e, item.id);
                            }
                            onClickSituationById && (item === null || item === void 0 ? void 0 : (ref = item.payload) === null || ref === void 0 ? void 0 : (ref1 = ref.dynamic_object) === null || ref1 === void 0 ? void 0 : ref1.situation_id) && onClickSituationById(item === null || item === void 0 ? void 0 : (ref2 = item.payload) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.dynamic_object) === null || ref3 === void 0 ? void 0 : ref3.situation_id);
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                className: "imageContainer",
                                children: item.image && item.image.key ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(EFinderImage/* default */.ZP, {
                                    image: item.image,
                                    h: EFinderImage/* EFinderImageSizes.avatar */.ny.avatar,
                                    alt: "profile_img"
                                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                    className: "image"
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                                className: "infoContainer",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("h6", {
                                        className: "name",
                                        children: item.title
                                    }),
                                    !isCheming && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                                        className: "playCount",
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(icon/* Icon */.JO, {
                                                icon: ic_play/* default */.Z,
                                                size: dist_esm/* Sizes.xsmall */.u8.xsmall,
                                                color: theme.var.gray400
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                                                children: (0,chat/* formatNumberMillion */.OQ)(((ref = item.payload.dynamic_object) === null || ref === void 0 ? void 0 : ref.message_count) || 0)
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }, "info_list_".concat(idx));
                })
            })
        ]
    });
};
/* harmony default export */ var outlook_ProfileByInfoPlacardFormList = (ProfileByInfoPlacardFormList);

// EXTERNAL MODULE: ./hooks/query/useUserQuery.ts
var useUserQuery = __webpack_require__(75319);
// EXTERNAL MODULE: ./api/chatbot.ts
var chatbot = __webpack_require__(23082);
// EXTERNAL MODULE: ./utils/query.ts
var utils_query = __webpack_require__(96261);
;// CONCATENATED MODULE: ./components/outlook/ProfileByInfoSectionFromList.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ProfileByInfoSectionFromList_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
function ProfileByInfoSectionFromList_templateObject() {
    var data = ProfileByInfoSectionFromList_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  padding: 10px 16px;\n  background-color: ",
        ";\n  margin-bottom: 4px;\n  ",
        " {\n    padding: 10px ",
        "px;\n  }\n  ",
        " {\n    padding: 10px ",
        "px;\n  }\n\n  .arrow-btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    top: 50%;\n    gap: 2px;\n    color: ",
        ";\n\n    p {\n      ",
        ";\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      margin-top: 0px;\n    }\n    i {\n      margin-bottom: 0;\n    }\n  }\n"
    ]);
    ProfileByInfoSectionFromList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProfileByInfoSectionFromList_templateObject1() {
    var data = ProfileByInfoSectionFromList_taggedTemplateLiteral([
        "\n  display: flex;\n  padding: ",
        "px;\n  border-radius: ",
        "px;\n\n  .imageContainer {\n    width: 50px;\n    height: 50px;\n    border-radius: ",
        "px;\n    margin-right: ",
        "px;\n    position: relative;\n    overflow: hidden;\n    align-self: center;\n  }\n  .image {\n    width: 50px;\n    height: 50px;\n    background-color: ",
        ";\n    border-radius: ",
        "px;\n    margin-right: ",
        "px;\n  }\n  .infoContainer {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    width: 100%;\n    overflow: hidden;\n  }\n  .name {\n    ",
        ";\n  }\n  .peek-ment {\n    margin: ",
        "px 0px;\n    ",
        ";\n    line-height: 145%;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n  }\n  .tags-container {\n    display: flex;\n    flex-direction: row;\n    gap: 4px;\n    flex-wrap: wrap;\n    max-height: 26px;\n    white-space: nowrap;\n    overflow: hidden;\n\n    & > p {\n      color: ",
        ";\n      ",
        ";\n    }\n  }\n  .stat-container {\n    display: flex;\n    margin-top: 10px;\n    gap: 10px;\n  }\n  .tab-container,\n  .balloon-container {\n    display: flex;\n    flex-direction: row;\n    gap: 2px;\n\n    & p {\n      ",
        ";\n    }\n\n    .tab {\n      color: ",
        ";\n    }\n    .balloon {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    ProfileByInfoSectionFromList_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ProfileByInfoSectionFromList_templateObject2() {
    var data = ProfileByInfoSectionFromList_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: flex-start;\n  height: 12px;\n  margin-top: ",
        "px;\n\n  p {\n    ",
        ";\n    margin-left: ",
        "px;\n  }\n"
    ]);
    ProfileByInfoSectionFromList_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




















var peekListTitle = function(theme) {
    return (0,emotion_react_browser_esm.css)(ProfileByInfoSectionFromList_templateObject(), theme.colors.main10, css/* media.tablet */.BC.tablet, dist_esm/* Spacing.xlarge */.Ki.xlarge, css/* media.desktop */.BC.desktop, dist_esm/* Spacing.xxlarge */.Ki.xxlarge, theme.var.gray500, dist_esm/* Typography.body12 */.ZT.body12);
};
var ProfileByInfoSectionFromList_cardContainerCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(ProfileByInfoSectionFromList_templateObject1(), dist_esm/* Spacing.small */.Ki.small, dist_esm/* Radius.small */.wU.small, dist_esm/* Radius.small */.wU.small, dist_esm/* Spacing.small */.Ki.small, theme.var.gray200, dist_esm/* Radius.small */.wU.small, dist_esm/* Spacing.small */.Ki.small, dist_esm/* Typography.h6 */.ZT.h6, dist_esm/* Spacing.xxsmall */.Ki.xxsmall, dist_esm/* Typography.body12 */.ZT.body12, theme.var.gray400, dist_esm/* Typography.body11 */.ZT.body11, dist_esm/* Typography.body12 */.ZT.body12, theme.colors.main500, theme.var.gray500);
};
var ProfileByInfoSectionFromList_profileCSS = (0,emotion_react_browser_esm.css)(ProfileByInfoSectionFromList_templateObject2(), dist_esm/* Spacing.small */.Ki.small, dist_esm/* Typography.body12 */.ZT.body12, dist_esm/* Spacing.xxhsmall */.Ki.xxhsmall);
var ProfileByInfoSectionFromList = function(param) {
    var data = param.data, componentKey = param.componentKey;
    var ref;
    var t = (0,esm/* useTranslation */.$G)().t;
    var theme = (0,emotion_element_c39617d8_browser_esm.u)();
    var web = (0,webview/* useWebView */.B9)().web;
    var ref1 = (0,global/* useGlobalContext */.bN)(), platform = ref1.platform, goodsName = ref1.goodsName, isCheming = ref1.isCheming;
    var router = (0,next_router.useRouter)();
    var userIdList = _toConsumableArray(new Set(data.profiles.map(function(item) {
        return item.payload.dynamic_object.chat_room.user_id;
    })));
    var characterIdList = _toConsumableArray(new Set(data.profiles.map(function(item) {
        return String(item.id);
    })));
    var useFetchUserList = (0,useUserQuery/* useUserQuery */.b)().useFetchUserList;
    var ref2 = useFetchUserList(userIdList), userList = ref2.data;
    var characterQuery = (0,utils_query/* useChatPaginationQuery */.aI)(constants/* QUERY_KEYS.CHARACTER.LIST */.U7.CHARACTER.LIST(characterIdList), function() {
        var _ref = _asyncToGenerator(function(param) {
            var pageParam;
            return __generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        pageParam = param.pageParam;
                        return [
                            4,
                            (0,chatbot/* fetchCharacters */.Em)({
                                ids: characterIdList
                            }, pageParam)
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }());
    var characterList = (ref = characterQuery.data) === null || ref === void 0 ? void 0 : ref.pages[0].items;
    var handleClickCard = function(id) {
        if (platform === constants/* Platform.web */.t4.web) {
            router.push("/play/chat-rooms/".concat(id, "/peek"));
        } else {
            web.openPage("/play/chat-rooms/".concat(id, "/peek"));
        }
    };
    var handleClickCharacterProfile = function(e, id) {
        e.stopPropagation();
        if (platform === constants/* Platform.web */.t4.web) {
            router.push("/play/characters/".concat(id));
        } else {
            web.openPage("/play/characters/".concat(id));
        }
    };
    var handleClickUserProfile = function(e, userId) {
        e.stopPropagation();
        var url = "/users/".concat(userId);
        if (platform === constants/* Platform.web */.t4.web) {
            return router.push(url);
        } else {
            web.openPage(url);
        }
    };
    var handleClickMore = function() {
        var url = "/play/peeks/".concat((0,misc/* toQueryString */.UK)({
            componentKey: componentKey
        }));
        if (platform === constants/* Platform.web */.t4.web) {
            router.push(url);
        }
        web.openPage(url);
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                css: peekListTitle,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("h5", {
                        children: data.title
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                        className: "arrow-btn",
                        onClick: handleClickMore,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                                children: t("더보기")
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(icon/* Icon */.JO, {
                                icon: icon/* ArrowRight */.ol,
                                color: theme.var.gray500,
                                size: dist_esm/* Sizes.xsmall */.u8.xsmall
                            })
                        ]
                    })
                ]
            }),
            data.profiles.map(function(profile, idx) {
                var ref, ref1, ref2;
                var item = profile.payload.dynamic_object;
                var isAnonimous = !!item.chat_room.peek.is_anonymous;
                var user = userList && !isAnonimous && (userList === null || userList === void 0 ? void 0 : userList.filter(function(user) {
                    return user.id === item.chat_room.user_id;
                })[0]);
                var tagList = characterList && ((ref = characterList === null || characterList === void 0 ? void 0 : characterList.filter(function(character) {
                    return character.id === profile.id;
                })[0]) === null || ref === void 0 ? void 0 : ref.tags);
                var _tap_count, _message_consumed_balloon, _comment_count;
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                            css: ProfileByInfoSectionFromList_cardContainerCSS,
                            onClick: function(e) {
                                if (isCheming) {
                                    return handleClickCharacterProfile(e, profile.id);
                                }
                                handleClickCard(profile.payload.dynamic_object.chat_room.id);
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                    className: "imageContainer",
                                    onClick: function(e) {
                                        return handleClickCharacterProfile(e, profile.id);
                                    },
                                    children: (profile === null || profile === void 0 ? void 0 : profile.image) && ((ref1 = profile.image) === null || ref1 === void 0 ? void 0 : ref1.key) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(EFinderImage/* default */.ZP, {
                                        image: profile.image,
                                        h: EFinderImage/* EFinderImageSizes.avatar */.ny.avatar,
                                        alt: "profile_img"
                                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                        className: "image",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(SvgIcon/* default */.Z, {
                                            icon: profile_32/* default */.Z,
                                            d: 50
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                                    className: "infoContainer",
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("h6", {
                                            className: "name",
                                            children: profile.title
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                                            className: "peek-ment",
                                            children: item.chat_room.peek.hooking_ment
                                        }),
                                        tagList && tagList.length && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                            className: "tags-container",
                                            children: tagList.map(function(tag) {
                                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                                                    children: t("#" + tag.name)
                                                }, tag.id);
                                            })
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                                            className: "stat-container",
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                                                    className: "tab-container",
                                                    children: [
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(icon/* Icon */.JO, {
                                                            icon: icon/* Tap */.Uw,
                                                            size: dist_esm/* Sizes.xsmall */.u8.xsmall,
                                                            color: theme.colors.main500
                                                        }),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                                                            className: "tab",
                                                            children: t((0,chat/* formatNumberMillion */.OQ)((_tap_count = item.chat_room.peek.tap_count) !== null && _tap_count !== void 0 ? _tap_count : 0))
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                                                    className: "balloon-container",
                                                    children: [
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(icon/* Icon */.JO, {
                                                            icon: icon/* DoubleBalloon */.P$,
                                                            size: dist_esm/* Sizes.xsmall */.u8.xsmall,
                                                            color: theme.var.gray500
                                                        }),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                                                            className: "balloon",
                                                            children: t((0,chat/* formatNumberMillion */.OQ)((_message_consumed_balloon = item.chat_room.message_consumed_balloon) !== null && _message_consumed_balloon !== void 0 ? _message_consumed_balloon : 0) + " ".concat(goodsName))
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                                                    className: "balloon-container",
                                                    children: [
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(icon/* Icon */.JO, {
                                                            icon: icon/* Comment */.sv,
                                                            size: dist_esm/* Sizes.xsmall */.u8.xsmall,
                                                            color: theme.var.gray500
                                                        }),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                                                            className: "balloon",
                                                            children: t((0,chat/* formatNumberMillion */.OQ)((_comment_count = item === null || item === void 0 ? void 0 : item.chat_room.peek.comment_count) !== null && _comment_count !== void 0 ? _comment_count : 0))
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        !isAnonimous && user && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                                            css: ProfileByInfoSectionFromList_profileCSS,
                                            onClick: function(e) {
                                                return handleClickUserProfile(e, user === null || user === void 0 ? void 0 : user.id);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(RoundAvatar/* default */.Z, {
                                                    size: 12,
                                                    picture: user === null || user === void 0 ? void 0 : user.picture
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                                                    children: t(user === null || user === void 0 ? void 0 : user.nickname)
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, profile.id),
                        ((ref2 = data.profiles) === null || ref2 === void 0 ? void 0 : ref2.length) - 1 !== idx && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Divider/* default */.Z, {
                            data: {
                                height: 1
                            }
                        })
                    ]
                });
            })
        ]
    });
};
/* harmony default export */ var outlook_ProfileByInfoSectionFromList = (ProfileByInfoSectionFromList);

;// CONCATENATED MODULE: ./components/characters/CharacterPlaCardList.tsx
function CharacterPlaCardList_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function CharacterPlaCardList_templateObject() {
    var data = CharacterPlaCardList_taggedTemplateLiteral([
        "\n  display: grid;\n  grid-auto-flow: column;\n  grid-template-rows: repeat(",
        ", 1fr);\n  column-gap: ",
        "px;\n  row-gap: 10px;\n  padding: 6px 16px ",
        "px;\n  margin-top: ",
        "px;\n  ",
        " {\n    padding: 6px ",
        "px ",
        "px;\n  }\n  ",
        " {\n    padding: 6px ",
        "px ",
        "px;\n  }\n"
    ]);
    CharacterPlaCardList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CharacterPlaCardList_templateObject1() {
    var data = CharacterPlaCardList_taggedTemplateLiteral([
        "\n  display: flex;\n  flex: 1;\n  width: 300px;\n  padding: ",
        "px;\n  border-radius: ",
        "px;\n  height: 74px;\n\n  box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, 0.05);\n\n  .imageContainer {\n    width: 50px;\n    height: 50px;\n    border-radius: ",
        "px;\n    margin-right: ",
        "px;\n    position: relative;\n    overflow: hidden;\n  }\n  .image {\n    width: 50px;\n    height: 50px;\n    background-color: ",
        ";\n    border-radius: ",
        "px;\n    margin-right: ",
        "px;\n  }\n  .infoContainer {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    width: 100%;\n    overflow: hidden;\n  }\n  .name {\n    ",
        ";\n  }\n  .info {\n    ",
        ";\n    color: ",
        ";\n    margin-top: ",
        "px;\n    margin-bottom: ",
        "px;\n  }\n  .desc {\n    width: 100%;\n    ",
        ";\n    font-size: 12px;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n  }\n"
    ]);
    CharacterPlaCardList_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}









var gridContainerCSS = function(rows) {
    return (0,emotion_react_browser_esm.css)(CharacterPlaCardList_templateObject(), rows, dist_esm/* Spacing.xsmall */.Ki.xsmall, dist_esm/* Spacing.large */.Ki.large, dist_esm/* Spacing.medium */.Ki.medium, css/* media.tablet */.BC.tablet, dist_esm/* Spacing.xlarge */.Ki.xlarge, dist_esm/* Spacing.large */.Ki.large, css/* media.desktop */.BC.desktop, dist_esm/* Spacing.xxlarge */.Ki.xxlarge, dist_esm/* Spacing.large */.Ki.large);
};
var CharacterPlaCardList_cardContainerCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(CharacterPlaCardList_templateObject1(), dist_esm/* Spacing.small */.Ki.small, dist_esm/* Radius.small */.wU.small, dist_esm/* Radius.small */.wU.small, dist_esm/* Spacing.small */.Ki.small, theme.var.gray200, dist_esm/* Radius.small */.wU.small, dist_esm/* Spacing.small */.Ki.small, dist_esm/* Typography.body12 */.ZT.body12, dist_esm/* Typography.body11 */.ZT.body11, theme.var.gray500, dist_esm/* Spacing.xxsmall */.Ki.xxsmall, dist_esm/* Spacing.xsmall */.Ki.xsmall, dist_esm/* Typography.h6 */.ZT.h6);
};
var CharacterPlaCardList = function(param) {
    var characters = param.characters, rowCount = param.rowCount, onClickCard = param.onClickCard, onClickProfile = param.onClickProfile;
    var isCheming = (0,global/* useGlobalContext */.bN)().isCheming;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(SwipableListContainer/* default */.Z, {
        className: "galleryCardListContainer",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
            className: "gridContainer",
            css: gridContainerCSS(rowCount),
            children: characters === null || characters === void 0 ? void 0 : characters.map(function(item, idx) {
                /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                    css: CharacterPlaCardList_cardContainerCSS,
                    onClick: function() {
                        return isCheming || (item === null || item === void 0 ? void 0 : item.type) === "official" ? onClickProfile && onClickProfile(item.id) : onClickCard && onClickCard(item.id);
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                            className: "imageContainer",
                            children: item.profile_image && item.profile_image.key ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(EFinderImage/* default */.ZP, {
                                image: item.profile_image,
                                h: EFinderImage/* EFinderImageSizes.avatar */.ny.avatar,
                                alt: "profile_img"
                            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                className: "image",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(SvgIcon/* default */.Z, {
                                    icon: profile_32/* default */.Z,
                                    d: 50
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                            className: "infoContainer",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("h6", {
                                    className: "name",
                                    children: item.name
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                                    className: "info",
                                    children: "".concat(item.information.age ? item.information.age : "N", "세 | ").concat(item.information.job ? item.information.job : "직업")
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                                    className: "desc",
                                    children: item.greeting
                                })
                            ]
                        })
                    ]
                }, "info_list_".concat(idx));
            })
        })
    });
};
/* harmony default export */ var characters_CharacterPlaCardList = (CharacterPlaCardList);

// EXTERNAL MODULE: ./components/modal/CharacterTagSelectionModal.tsx
var CharacterTagSelectionModal = __webpack_require__(26538);
// EXTERNAL MODULE: ./api/character.ts
var character = __webpack_require__(90714);
;// CONCATENATED MODULE: ./components/outlook/SwipableTagList.tsx
function SwipableTagList_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function SwipableTagList_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return SwipableTagList_arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function SwipableTagList_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function SwipableTagList_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function SwipableTagList_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function SwipableTagList_toConsumableArray(arr) {
    return SwipableTagList_arrayWithoutHoles(arr) || SwipableTagList_iterableToArray(arr) || SwipableTagList_unsupportedIterableToArray(arr) || SwipableTagList_nonIterableSpread();
}
function SwipableTagList_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return SwipableTagList_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return SwipableTagList_arrayLikeToArray(o, minLen);
}
function SwipableTagList_templateObject() {
    var data = SwipableTagList_taggedTemplateLiteral([
        "\n  padding: 0 ",
        "px;\n  margin-bottom: ",
        "px;\n  ",
        " {\n    padding: 0 ",
        "px;\n  }\n  ",
        " {\n    padding: 0 ",
        "px;\n  }\n"
    ]);
    SwipableTagList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SwipableTagList_templateObject1() {
    var data = SwipableTagList_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n  padding: 0 ",
        "px;\n  ",
        " {\n    padding: 0 ",
        "px;\n  }\n  ",
        " {\n    padding: 0 ",
        "px;\n  }\n\n  p {\n    ",
        "\n    color:",
        ";\n  }\n"
    ]);
    SwipableTagList_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SwipableTagList_templateObject2() {
    var data = SwipableTagList_taggedTemplateLiteral([
        "\n    display: flex;\n    align-items: center;\n    margin-left: ",
        "px;\n    svg {\n      height: 24px;\n    }\n\n    button {\n      background-color: ",
        ";\n    }\n\n    .icon-text {\n      span {\n        color: ",
        ";\n      }\n      height: 31px;\n    }\n  "
    ]);
    SwipableTagList_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}











// const containerCSS = (rowCount: number) => css`
//   display: grid;
//   grid-auto-flow: column;
//   grid-template-rows: repeat(${rowCount}, 1fr);
//   .skeleton {
//     height: ${62}px;
//     width: 300px;
//     padding: ${Spacing.small}px;
//     margin: ${Spacing.small}px;
//     border-radius: ${Radius.small}px;
//   }
// `;
var titleCSS = (0,emotion_react_browser_esm.css)(SwipableTagList_templateObject(), dist_esm/* Spacing.medium */.Ki.medium, dist_esm/* Spacing.xsmall */.Ki.xsmall, css/* media.tablet */.BC.tablet, dist_esm/* Spacing.xlarge */.Ki.xlarge, css/* media.desktop */.BC.desktop, dist_esm/* Spacing.xxlarge */.Ki.xxlarge);
var tagContainerCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(SwipableTagList_templateObject1(), dist_esm/* Spacing.xsmall */.Ki.xsmall, css/* media.tablet */.BC.tablet, dist_esm/* Spacing.medium */.Ki.medium, css/* media.desktop */.BC.desktop, dist_esm/* Spacing.xlarge */.Ki.xlarge, dist_esm/* Typography.body12 */.ZT.body12, theme.var.gray500);
};
var tagCSS = function(selected) {
    return function(theme) {
        return (0,emotion_react_browser_esm.css)(SwipableTagList_templateObject2(), dist_esm/* Spacing.xsmall */.Ki.xsmall, selected ? "".concat(theme.var.black, ";") : "null", selected ? "".concat(theme.var.white, ";") : "".concat(theme.var.black));
    };
};
var CharacterPlaCardFetcher = function(props) {
    var ref, ref1;
    var selectedIds = props.selectedIds;
    var query = (0,utils_query/* useChatPaginationQuery */.aI)(constants/* QUERY_KEYS.CHARACTER.TAG */.U7.CHARACTER.TAG(selectedIds, "stat__message_count"), function() {
        return (0,character/* getCharacterList */.IZ)({
            tag_ids: selectedIds,
            order_by: "stat__message_count"
        }, 1, props.contentCount);
    }, {
        enabled: !!(selectedIds === null || selectedIds === void 0 ? void 0 : selectedIds.length)
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(emotion_react_jsx_runtime_browser_esm.Fragment, {
        children: ((ref = query.data) === null || ref === void 0 ? void 0 : ref.pages[0].items) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(characters_CharacterPlaCardList, _objectSpreadProps(_objectSpread({}, props), {
            characters: (ref1 = query.data) === null || ref1 === void 0 ? void 0 : ref1.pages[0].items
        }))
    });
};
var SwipableTagList = function(param) {
    var tags = param.tags, title = param.title, onClickProfile = param.onClickProfile, onClickCard = param.onClickCard, _rowCount = param.rowCount, rowCount = _rowCount === void 0 ? 4 : _rowCount, _contentCount = param.contentCount, contentCount = _contentCount === void 0 ? 16 : _contentCount;
    var ref = (0,react.useState)([]), selected = ref[0], setSelected = ref[1];
    (0,react.useEffect)(function() {
        if (tags === null || tags === void 0 ? void 0 : tags.length) {
            var ref, ref1, ref2;
            setSelected([
                (ref = tags[0]) === null || ref === void 0 ? void 0 : ref.id, 
            ].concat(SwipableTagList_toConsumableArray((ref2 = (ref1 = tags[0]) === null || ref1 === void 0 ? void 0 : ref1.payload.dynamic_object) === null || ref2 === void 0 ? void 0 : ref2.related_tag_ids)));
        }
    }, [
        tags
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("h5", {
                css: titleCSS,
                children: "".concat(title)
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                css: tagContainerCSS,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(SwipableListContainer/* default */.Z, {
                    className: "tagList",
                    children: tags.map(function(item, index) {
                        /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                            css: tagCSS(selected[0] === item.id),
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(CharacterTagSelectionModal/* CharacterTag */._P, {
                                name: item.name,
                                onClick: function() {
                                    var ref, ref1;
                                    return setSelected([
                                        item.id, 
                                    ].concat(SwipableTagList_toConsumableArray((ref = item.payload) === null || ref === void 0 ? void 0 : (ref1 = ref.dynamic_object) === null || ref1 === void 0 ? void 0 : ref1.related_tag_ids)));
                                }
                            })
                        }, "tag_".concat(index));
                    })
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(CharacterPlaCardFetcher, {
                selectedIds: selected,
                onClickCard: onClickCard,
                onClickProfile: onClickProfile,
                rowCount: rowCount,
                contentCount: contentCount
            })
        ]
    });
};
/* harmony default export */ var outlook_SwipableTagList = (SwipableTagList);

;// CONCATENATED MODULE: ./components/outlook/OutlookComponent.tsx
















var OutlookComponent = /*#__PURE__*/ (0,react.memo)(function(param) {
    var component = param.component, order = param.order, onClickSituation = param.onClickSituation, onClickProfile = param.onClickProfile, handleCreateChatRoom = param.handleCreateChatRoom, onClickGroundCharacter = param.onClickGroundCharacter, onClickGround = param.onClickGround, onClickSituationById = param.onClickSituationById, onClickChoice = param.onClickChoice;
    // const { isTablet } = useGlobalContext();
    var handleClickProfile = function(id) {
        if (onClickProfile) {
            onClickProfile(id);
        }
    };
    var handleClickGround = function(id, groundId) {
        (0,misc/* setFlow */.kB)({
            name: "그라운드 큐레이션"
        });
        if (onClickGround) {
            onClickGround(id, groundId);
        }
    };
    //component.view_type === 'profile_by_choice_form_gallery
    if (component.view_type === "profile_by_choice_form_gallery") {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(outlook_ProfileByChoiceFromGallery, {
            data: component.data,
            componentKey: component === null || component === void 0 ? void 0 : component.key,
            onClickGroundCharacrer: onClickGroundCharacter,
            onClickChoice: onClickChoice
        }, order);
    }
    if (component.view_type === "tag_list") {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(outlook_SwipableTagList, {
            tags: component.data.tags,
            title: component.data.title,
            onClickCard: handleCreateChatRoom,
            onClickProfile: onClickProfile,
            rowCount: component.data.row_count,
            contentCount: component.data.content_count
        }, order);
    }
    if (component.view_type === "divider_line") {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Divider/* default */.Z, {
            data: component.data
        });
    }
    if (component.view_type === "full_screen_banner") {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Banner/* default */.ZP, {
            name: "play-full-screen=banner",
            size: Banner/* BannerSize.playHome */.Kj.playHome,
            items: component.data.banners,
            isBorder: false
        }, order);
    }
    if (component.view_type === "profile_gallery") {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(outlook_ProfileGallery, {
            data: component.data
        });
    }
    if (component.view_type === "content_gallery_with_header") {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(outlook_ContentGalleryWithHeader, {
            data: component.data,
            onClickProfile: handleClickProfile,
            onClickSituation: onClickSituation && onClickSituation
        }, order);
    }
    if (component.view_type === "profile_with_message") {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(outlook_ProfileWithMessage, {
            data: component.data,
            onClickProfile: handleClickProfile
        }, order);
    }
    if (component.view_type === "content_by_profile_form_gallery") {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(outlook_ContentByProfileFromGallery, {
            order: order,
            data: component.data,
            onClickGround: handleClickGround,
            onClickSituation: onClickSituationById && onClickSituationById,
            onClickProfile: handleClickProfile
        }, order);
    }
    if (component.view_type === "profile_by_info_card_form_gallery") {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(outlook_ProfileByInfoCardFormGallery, {
            data: component.data,
            onClickCard: handleCreateChatRoom,
            onClickProfile: onClickProfile,
            componentKey: component.key
        }, order);
    }
    if (component.view_type === "profile_by_info_placard_form_gallery") {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(outlook_ProfileByInfoPlacardFormGallery, {
            data: component.data,
            onClickCard: handleCreateChatRoom,
            onClickProfile: onClickProfile,
            componentKey: component.key
        }, order);
    }
    if (component.view_type === "profile_by_info_placard_form_list") {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(outlook_ProfileByInfoPlacardFormList, {
            data: component.data,
            onClickSituationById: onClickSituationById && onClickSituationById
        }, order);
    }
    if (component.view_type === "placard_banner") {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(PlacardBanner, {
            data: component.data
        }, order);
    }
    if (component.view_type === "profile_by_info_section_form_list") {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(outlook_ProfileByInfoSectionFromList, {
            data: component.data,
            componentKey: component === null || component === void 0 ? void 0 : component.key
        }, order);
    }
    return null;
}, function(prevProps, nextProps) {
    return prevProps.component === nextProps.component && prevProps.onClickSituation === nextProps.onClickSituation && prevProps.onClickProfile === nextProps.onClickProfile;
});
OutlookComponent.displayName = "OutlookComponent";
/* harmony default export */ var outlook_OutlookComponent = (/*#__PURE__*/(0,react.memo)(OutlookComponent));


/***/ }),

/***/ 48782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11717);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9150);
/* harmony import */ var _Frame__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19827);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  padding: ",
        "px ",
        "px;\n  gap: ",
        "px;\n  margin-top: ",
        "px;\n\n  .avatar div:nth-of-type(1) {\n    width: 44px;\n    height: 44px;\n    border-radius: 50px;\n  }\n\n  .info {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: ",
        "px;\n  }\n\n  .info div:nth-of-type(1) {\n    width: 30%;\n    height: 18px;\n  }\n\n  .info div:nth-of-type(2) {\n    width: 80%;\n    height: 12px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var characterSkeletonCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject(), chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Spacing.small */ .Ki.small, chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Spacing.medium */ .Ki.medium, chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Spacing.medium */ .Ki.medium, chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Spacing.small */ .Ki.small, chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Spacing.xxsmall */ .Ki.xxsmall);
var CharacterSkeleton = function() {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
        css: characterSkeletonCSS,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
                className: "avatar",
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_Frame__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {})
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
                className: "info",
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_Frame__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {}),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_Frame__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {})
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CharacterSkeleton);


/***/ }),

/***/ 19827:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11717);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9150);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  from {\n    background-color: ",
        ";\n  }\n\n  to {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  background-color: ",
        ";\n  border-radius: ",
        "px;\n  animation: ",
        " 2s\n    alternate infinite ease-in-out;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var skeletonKeyframe = function(fromColor, toColor) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__.keyframes)(_templateObject(), fromColor, toColor);
};
var frameCSS = function(theme) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__.css)(_templateObject1(), theme.var.gray100, chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Radius.small */ .wU.small, skeletonKeyframe(theme.var.gray100, theme.var.gray200));
};
var Frame = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
        css: frameCSS,
        className: className
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Frame);


/***/ }),

/***/ 6668:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11717);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39953);
/* harmony import */ var react_intersection_observer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74001);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  overflow: hidden;\n  max-height: 100vh;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var _SKELETON_LIST = _toConsumableArray(new Array(10).keys());
var skeletonListCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__.css)(_templateObject());
var SkeletonList = function(param) {
    var Skeleton = param.skeleton;
    var ref = (0,react_intersection_observer__WEBPACK_IMPORTED_MODULE_2__/* .useInView */ .YD)(), inView = ref.inView, ref1 = ref.ref, entry = ref.entry;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(), skeletonHeight = ref2[0], setSkeletonHeight = ref2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (inView && entry) {
            setSkeletonHeight(window.innerHeight - entry.boundingClientRect.top);
        }
    }, [
        inView
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
        css: skeletonListCSS,
        ref: ref1,
        style: skeletonHeight ? {
            height: skeletonHeight
        } : undefined,
        children: _SKELETON_LIST.map(function(i) {
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Skeleton, {}, "skeleton-".concat(i));
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SkeletonList);


/***/ }),

/***/ 48049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ useOutlook; }
/* harmony export */ });
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54909);
/* harmony import */ var _api_chatbot__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23082);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39854);
/* harmony import */ var _utils_query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96261);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};




var useOutlook = function() {
    var usePageOutlook = function(pageName, options) {
        var perPage = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 20;
        var query = (0,_utils_query__WEBPACK_IMPORTED_MODULE_3__/* .useChatPaginationQuery */ .aI)(_constants__WEBPACK_IMPORTED_MODULE_2__/* .QUERY_KEYS.OUT_LOOK.PAGE */ .U7.OUT_LOOK.PAGE(pageName), function() {
            var _ref = _asyncToGenerator(function(param) {
                var pageParam;
                return __generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            pageParam = param.pageParam;
                            return [
                                4,
                                (0,_api_chatbot__WEBPACK_IMPORTED_MODULE_1__/* .getPaginationOutlookPage */ .rH)(pageName, pageParam, perPage)
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                    }
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }(), options);
        return query;
    };
    var useComponentOutlook = function(key, options) {
        var query = (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useQuery)(_constants__WEBPACK_IMPORTED_MODULE_2__/* .QUERY_KEYS.OUT_LOOK.COMPONENT */ .U7.OUT_LOOK.COMPONENT(key), function() {
            return (0,_api_chatbot__WEBPACK_IMPORTED_MODULE_1__/* .getOutlookComponent */ .bc)(key);
        }, options);
        return query;
    };
    var useComponentOutlookRenderItem = function(key, options) {
        try {
            var query = (0,_utils_query__WEBPACK_IMPORTED_MODULE_3__/* .useChatPaginationQuery */ .aI)(_constants__WEBPACK_IMPORTED_MODULE_2__/* .QUERY_KEYS.OUT_LOOK.COMPONENT_ITEM */ .U7.OUT_LOOK.COMPONENT_ITEM(key), function(param) {
                var pageParam = param.pageParam;
                return (0,_api_chatbot__WEBPACK_IMPORTED_MODULE_1__/* .getOutlookComponentRenderItem */ .Ax)(key, pageParam);
            }, _objectSpread({}, options));
            return query;
        } catch (e) {
            return undefined;
        }
    };
    return {
        usePageOutlook: usePageOutlook,
        useComponentOutlook: useComponentOutlook,
        useComponentOutlookRenderItem: useComponentOutlookRenderItem
    };
};


/***/ }),

/***/ 75319:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ useUserQuery; }
/* harmony export */ });
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54909);
/* harmony import */ var date_fns_minutesToMilliseconds__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72218);
/* harmony import */ var _api_common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98379);
/* harmony import */ var _api_user__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9622);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39854);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};





var useUserQuery = function() {
    var useFetchUser = function(userId, options) {
        return (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useQuery)(_constants__WEBPACK_IMPORTED_MODULE_3__/* .QUERY_KEYS.USER.ONE */ .U7.USER.ONE(userId), function() {
            return (0,_api_user__WEBPACK_IMPORTED_MODULE_2__/* .fetchUser */ .BT)(userId);
        }, _objectSpread({
            staleTime: (0,date_fns_minutesToMilliseconds__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(15),
            cacheTime: (0,date_fns_minutesToMilliseconds__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(15),
            enabled: !!userId
        }, options));
    };
    var useFetchUserList = function(userIds, options) {
        return (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useQuery)(_constants__WEBPACK_IMPORTED_MODULE_3__/* .QUERY_KEYS.USER.LIST */ .U7.USER.LIST(userIds), function() {
            return (0,_api_user__WEBPACK_IMPORTED_MODULE_2__/* .fetchUserList */ .ET)(userIds);
        }, _objectSpread({
            staleTime: (0,date_fns_minutesToMilliseconds__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(15),
            cacheTime: (0,date_fns_minutesToMilliseconds__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(15),
            enabled: !!(userIds === null || userIds === void 0 ? void 0 : userIds.length)
        }, options));
    };
    var useFetchFanClub = function(userId) {
        var query = (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useQuery)(_constants__WEBPACK_IMPORTED_MODULE_3__/* .QUERY_KEYS.FAN.INFO */ .U7.FAN.INFO(userId), function() {
            return (0,_api_user__WEBPACK_IMPORTED_MODULE_2__/* .fetchFanClub */ .YS)(userId);
        }, {
            staleTime: (0,date_fns_minutesToMilliseconds__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(5),
            cacheTime: (0,date_fns_minutesToMilliseconds__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(5)
        });
        return query;
    };
    //me로 옮길 쿼리
    var useFetchMyFanClub = function() {
        var query = (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useQuery)(_constants__WEBPACK_IMPORTED_MODULE_3__/* .QUERY_KEYS.MY_FAN_CLUB.INFO */ .U7.MY_FAN_CLUB.INFO, function() {
            return (0,_api_user__WEBPACK_IMPORTED_MODULE_2__/* .fetchMyFanClub */ .L_)();
        }, {
            staleTime: (0,date_fns_minutesToMilliseconds__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(5),
            cacheTime: (0,date_fns_minutesToMilliseconds__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(5)
        });
        return query;
    };
    var useFetchSocialProviders = function() {
        var query = (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useQuery)(_constants__WEBPACK_IMPORTED_MODULE_3__/* .QUERY_KEYS.USER.SOCIAL_PROVIDER */ .U7.USER.SOCIAL_PROVIDER, function() {
            return (0,_api_user__WEBPACK_IMPORTED_MODULE_2__/* .fetchSocialProviders */ .E)();
        });
        return query;
    };
    var ref = (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useMutation)(function() {
        var _ref = _asyncToGenerator(function(email) {
            return __generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,_api_user__WEBPACK_IMPORTED_MODULE_2__/* .postEmailCrendentialToUser */ .U3)(email)
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(email) {
            return _ref.apply(this, arguments);
        };
    }()), postEmailCredential = ref.mutateAsync;
    var ref1 = (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useMutation)(/*#__PURE__*/ _asyncToGenerator(function() {
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,_api_user__WEBPACK_IMPORTED_MODULE_2__/* .postMyEmailVerification */ .xS)()
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    })), postEmailVerification = ref1.mutate;
    var ref2 = (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useMutation)(function() {
        var _ref = _asyncToGenerator(function(param) {
            var social, accessToken, idToken;
            return __generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        social = param.social, accessToken = param.accessToken, idToken = param.idToken;
                        return [
                            4,
                            (0,_api_user__WEBPACK_IMPORTED_MODULE_2__/* .postSocial */ .ov)(social, accessToken, idToken)
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()), postSocialPeristalsis = ref2.mutateAsync;
    var ref3 = (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useMutation)(function() {
        var _ref = _asyncToGenerator(function(param) {
            var social;
            return __generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        social = param.social;
                        return [
                            4,
                            (0,_api_user__WEBPACK_IMPORTED_MODULE_2__/* .disconnectSocial */ .e1)(social)
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()), disconnectSocialPeristalsis = ref3.mutateAsync;
    var ref4 = (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useMutation)(/*#__PURE__*/ _asyncToGenerator(function() {
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,_api_user__WEBPACK_IMPORTED_MODULE_2__/* .unregisterUser */ .zD)()
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    })), deleteUser = ref4.mutateAsync;
    var ref5 = (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useMutation)(function(reason) {
        return (0,_api_common__WEBPACK_IMPORTED_MODULE_1__/* .postReasons */ .DS)(_constants__WEBPACK_IMPORTED_MODULE_3__/* .UniversalReason.unregisterUser */ .D2.unregisterUser, {
            reason: reason
        });
    }), postUnregisterReasons = ref5.mutateAsync;
    return {
        disconnectSocialPeristalsis: disconnectSocialPeristalsis,
        useFetchUser: useFetchUser,
        useFetchUserList: useFetchUserList,
        useFetchFanClub: useFetchFanClub,
        useFetchMyFanClub: useFetchMyFanClub,
        postEmailCredential: postEmailCredential,
        postEmailVerification: postEmailVerification,
        useFetchSocialProviders: useFetchSocialProviders,
        postSocialPeristalsis: postSocialPeristalsis,
        deleteUser: deleteUser,
        postUnregisterReasons: postUnregisterReasons
    };
};


/***/ }),

/***/ 88797:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39953);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIcPlay = function SvgIcPlay(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#BBB",
    d: "M9.917 5.265 2.899.972a.78.78 0 0 0-1.185.658v8.585a.776.776 0 0 0 1.187.659L9.917 6.58a.77.77 0 0 0 0-1.315v-.001m-7.423 4.941v-8.57l7.005 4.287-7.005 4.283"
  })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgIcPlay);

/***/ })

}]);